/**
 * Playable Learn letter-course game CONTENT extracted from Pixley iOS
 * (Pixley-iOS/Learn AlphabetF–Z). Do not invent assets or answers not
 * present in the Swift banks/views.
 *
 * Game object keys are MiniGame rawValue (id) for progress matching.
 * When Swift case name differs, `swiftCase` is included.
 *
 * Engines: soundSort | sentenceBuilder | letterHunt | catchFalling |
 * pictureGrid | bubblePop | guidedTrace | pictureMatch | storyPages |
 * discovery | callSequence | wordBuilder | strokeAssembly | memoryPair |
 * soundPairs | soundPosition | genericTap | sentenceMeaning
 */

/** @typedef {{ word: string, assetName: string, isTarget?: boolean, startingSound?: string }} PhonicsItem */
/** @typedef {{ x: number, y: number }} NormPoint */

export const LETTER_GAME_CONFIGS_FZ = {
  F: {
    forestDiscovery: {
      engine: "discovery",
      title: "Friendly F Forest",
      prompt: "Tap each fern to meet a word that starts with F.",
      background: "f_game_friendly_forest_discovery_bg",
      items: [
        { word: "fish", assetName: "f_word_fish", isTarget: true },
        { word: "fox", assetName: "f_word_fox", isTarget: true },
        { word: "frog", assetName: "f_word_frog", isTarget: true },
        { word: "fan", assetName: "f_word_fan", isTarget: true },
        { word: "fig", assetName: "f_word_fig", isTarget: true },
        { word: "feather", assetName: "f_word_feather", isTarget: true },
      ],
    },
    soundSort: {
      engine: "soundSort",
      title: "F or Not F?",
      prompt: "Drag each picture to Starts with F or Not F.",
      background: "f_game_feather_field_sort_bg",
      zones: {
        target: {
          title: "Starts with F",
        },
        other: {
          title: "Not F",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "fish", assetName: "f_word_fish", isTarget: true },
        { word: "fox", assetName: "f_word_fox", isTarget: true },
        { word: "frog", assetName: "f_word_frog", isTarget: true },
        { word: "fan", assetName: "f_word_fan", isTarget: true },
        { word: "fig", assetName: "f_word_fig", isTarget: true },
        { word: "feather", assetName: "f_word_feather", isTarget: true },
        { word: "flower", assetName: "f_word_flower", isTarget: true },
        { word: "flag", assetName: "f_word_flag", isTarget: true },
        { word: "flamingo", assetName: "f_word_flamingo", isTarget: true },
        { word: "firefly", assetName: "f_word_firefly", isTarget: true },
      ],
      distractorItems: [
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false },
      ],
    },
    fireflyHunt: {
      engine: "letterHunt",
      title: "Firefly Letter Hunt",
      prompt: "Tap every uppercase F and lowercase f.",
      background: "f_game_firefly_festival_hunt_bg",
      targets: [
        "F",
        "f",
      ],
      targetCopies: 6,
      distractors: [
        "E",
        "T",
        "L",
        "P",
        "R",
        "B",
        "H",
        "K",
        "I",
        "A",
        "M",
        "N",
        "e",
        "t",
        "l",
        "p",
        "r",
        "b",
        "h",
        "i",
      ],
      distractorCount: 12,
      layoutPoints: [
        [0.12, 0.22], [0.32, 0.2], [0.53, 0.24], [0.78, 0.2], [0.9, 0.33],
        [0.15, 0.4], [0.4, 0.38], [0.66, 0.42], [0.84, 0.5], [0.1, 0.57],
        [0.31, 0.6], [0.54, 0.56], [0.72, 0.66], [0.91, 0.7], [0.16, 0.78],
        [0.38, 0.83], [0.62, 0.77], [0.82, 0.85],
      ],
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "Find the F Picture",
      prompt: "Listen, then tap the F picture I name.",
      background: "f_game_fountain_garden_match_bg",
      items: [
        { word: "fish", assetName: "f_word_fish", isTarget: true },
        { word: "fox", assetName: "f_word_fox", isTarget: true },
        { word: "frog", assetName: "f_word_frog", isTarget: true },
        { word: "fan", assetName: "f_word_fan", isTarget: true },
        { word: "fig", assetName: "f_word_fig", isTarget: true },
        { word: "feather", assetName: "f_word_feather", isTarget: true },
        { word: "flower", assetName: "f_word_flower", isTarget: true },
        { word: "flag", assetName: "f_word_flag", isTarget: true },
        { word: "flamingo", assetName: "f_word_flamingo", isTarget: true },
      ],
    },
    flowerGlow: {
      engine: "genericTap",
      title: "Glow the F Flowers",
      prompt: "Tap a flower only when its picture starts with F.",
      background: "f_game_flower_glow_action_bg",
      items: [
        { word: "fish", assetName: "f_word_fish", isTarget: true },
        { word: "fox", assetName: "f_word_fox", isTarget: true },
        { word: "frog", assetName: "f_word_frog", isTarget: true },
        { word: "fan", assetName: "f_word_fan", isTarget: true },
        { word: "fig", assetName: "f_word_fig", isTarget: true },
        { word: "feather", assetName: "f_word_feather", isTarget: true },
        { word: "flower", assetName: "f_word_flower", isTarget: true },
        { word: "flag", assetName: "f_word_flag", isTarget: true },
        { word: "flamingo", assetName: "f_word_flamingo", isTarget: true },
        { word: "firefly", assetName: "f_word_firefly", isTarget: true },
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceBuilder",
      title: "Build an F Sentence",
      prompt: "Listen, then tap each word in order.",
      background: "f_game_forest_story_sentence_bg",
      roundSize: 5,
      sentences: [
        {
          words: [
            "Fish",
            "can",
            "swim.",
          ],
          choices: [
            "can",
            "swim.",
            "Fish",
          ],
          focusWord: "fish",
        },
        {
          words: [
            "A",
            "fox",
            "runs.",
          ],
          choices: [
            "fox",
            "runs.",
            "A",
          ],
          focusWord: "fox",
        },
        {
          words: [
            "The",
            "frog",
            "hops.",
          ],
          choices: [
            "hops.",
            "The",
            "frog",
          ],
          focusWord: "frog",
        },
        {
          words: [
            "A",
            "flower",
            "grows.",
          ],
          choices: [
            "flower",
            "grows.",
            "A",
          ],
          focusWord: "flower",
        },
        {
          words: [
            "I",
            "see",
            "a",
            "flag.",
          ],
          choices: [
            "flag.",
            "I",
            "a",
            "see",
          ],
          focusWord: "flag",
        },
      ],
      focusAssets: {
        fish: "f_word_fish",
        fox: "f_word_fox",
        frog: "f_word_frog",
        flower: "f_word_flower",
        flag: "f_word_flag",
      },
    },
    traceF: {
      engine: "guidedTrace",
      title: "Trace F and f",
      prompt: "Trace F and f",
      background: "f_game_friendly_fort_trace_bg",
      cases: {
        uppercase: {
          glyph: "F",
          prompts: [],
          strokes: [
            [{ x: 0.31, y: 0.12 }, { x: 0.31, y: 0.88 }],
            [{ x: 0.31, y: 0.12 }, { x: 0.75, y: 0.12 }],
            [{ x: 0.31, y: 0.49 }, { x: 0.66, y: 0.49 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "f",
          prompts: [],
          strokes: [
            [],
            [],
          ],
          strokeCount: 2,
        },
      }
    },
  },
  G: {
    greenhouseDiscovery: {
      engine: "discovery",
      title: "Greenhouse G Discovery",
      prompt: "Tap each pod. Listen for G like goat.",
      background: "g_game_greenhouse_discovery_bg",
      items: [
        { word: "goat", assetName: "g_word_goat", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goose", assetName: "g_word_goose", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "grape", assetName: "g_word_grape", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gift", assetName: "g_word_gift", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "garden", assetName: "g_word_garden", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gate", assetName: "g_word_gate", isTarget: true, startingSound: "beginsLikeGoat" },
      ],
    },
    goatCallSequence: {
      engine: "callSequence",
      title: "Goat Garden Word Call",
      prompt: "Every G word call remembered",
      background: "g_game_garden_gate_sort_bg",
      rounds: [
        {
          id: "goat",
          sequence: [
            "goat",
          ],
          choices: [
            "goat",
            "goose",
            "grape",
            "gift",
          ],
        },
        {
          id: "gift-garden",
          sequence: [
            "gift",
            "garden",
          ],
          choices: [
            "gift",
            "garden",
            "gate",
            "goldfish",
          ],
        },
        {
          id: "gate-goldfish",
          sequence: [
            "gate",
            "goldfish",
          ],
          choices: [
            "gate",
            "goldfish",
            "glove",
            "gorilla",
          ],
        },
      ],
      items: [
        { word: "goat", assetName: "g_word_goat", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goose", assetName: "g_word_goose", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "grape", assetName: "g_word_grape", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gift", assetName: "g_word_gift", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "garden", assetName: "g_word_garden", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gate", assetName: "g_word_gate", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goldfish", assetName: "g_word_goldfish", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "glove", assetName: "g_word_glove", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "guitar", assetName: "g_word_guitar", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gorilla", assetName: "g_word_gorilla", isTarget: true, startingSound: "beginsLikeGoat" },
      ],
    },
    letterHunt: {
      engine: "letterHunt",
      title: "Glow Grove G Hunt",
      prompt: "Tap every uppercase G and lowercase g.",
      background: "g_game_glow_grove_hunt_bg",
      tokenSequence: [
        "G",
        "g",
        "A",
        "G",
        "C",
        "g",
        "D",
        "G",
        "e",
        "g",
        "H",
        "o",
      ],
      layoutPoints: [
        [0.17, 0.3], [0.5, 0.28], [0.82, 0.31], [0.29, 0.46], [0.68, 0.45],
        [0.11, 0.59], [0.48, 0.61], [0.87, 0.58], [0.24, 0.75], [0.61, 0.77],
        [0.84, 0.79], [0.43, 0.87],
      ],
      distractorCount: 6,
      targetCopies: 6,
      targets: [
        "G",
        "g",
      ],
      distractors: [
        "A",
        "C",
        "D",
        "e",
        "H",
        "o",
      ]
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "Gazebo Picture Match",
      prompt: "Listen, then tap the picture I name.",
      background: "g_game_gazebo_picture_match_bg",
      items: [
        { word: "goat", assetName: "g_word_goat", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goose", assetName: "g_word_goose", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "grape", assetName: "g_word_grape", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gift", assetName: "g_word_gift", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "garden", assetName: "g_word_garden", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gate", assetName: "g_word_gate", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goldfish", assetName: "g_word_goldfish", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "glove", assetName: "g_word_glove", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "guitar", assetName: "g_word_guitar", isTarget: true, startingSound: "beginsLikeGoat" },
      ],
    },
    gardenMeaning: {
      engine: "sentenceMeaning",
      title: "G Meaning Garden",
      prompt: "Listen to the clue, then choose its picture.",
      background: "g_game_grape_gather_bg",
      prompts: [
        {
          id: "goat",
          prompt: "Find the friendly farm animal with horns.",
          answer: "goat",
          choices: [
            "goat",
            "grape",
            "gift",
            "glove",
          ],
        },
        {
          id: "grape",
          prompt: "Find the little fruit that grows in a bunch.",
          answer: "grape",
          choices: [
            "grape",
            "goat",
            "gate",
            "goldfish",
          ],
        },
        {
          id: "glove",
          prompt: "Find what you can wear on your hand.",
          answer: "glove",
          choices: [
            "glove",
            "gift",
            "goose",
            "garden",
          ],
        },
        {
          id: "gift",
          prompt: "Find the wrapped surprise with a bow.",
          answer: "gift",
          choices: [
            "gift",
            "glove",
            "gorilla",
            "grape",
          ],
        },
        {
          id: "goldfish",
          prompt: "Find the small orange fish.",
          answer: "goldfish",
          choices: [
            "goldfish",
            "goat",
            "gate",
            "goose",
          ],
        },
      ],
      wordBank: [
        { word: "goat", assetName: "g_word_goat", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goose", assetName: "g_word_goose", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "grape", assetName: "g_word_grape", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gift", assetName: "g_word_gift", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "garden", assetName: "g_word_garden", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gate", assetName: "g_word_gate", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "goldfish", assetName: "g_word_goldfish", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "glove", assetName: "g_word_glove", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "guitar", assetName: "g_word_guitar", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "gorilla", assetName: "g_word_gorilla", isTarget: true, startingSound: "beginsLikeGoat" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "ball", assetName: "a_word_ball", isTarget: false, startingSound: "other" },
        { word: "bus", assetName: "a_word_bus", isTarget: false, startingSound: "other" },
        { word: "egg", assetName: "a_word_egg", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "a_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "tree", assetName: "a_word_tree", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceBuilder",
      title: "Build a G Sentence",
      prompt: "Tap the words in sentence order.",
      background: "g_game_garden_sentence_bg",
      roundSize: 3,
      sentences: [
        {
          words: [
            "A",
            "goat",
            "eats",
            "grass",
          ],
          focusWord: "goat",
          pictureAssetName: "g_word_goat",
          pictureLabel: "Goat",
        },
        {
          words: [
            "The",
            "goose",
            "sees",
            "a",
            "gate",
          ],
          focusWord: "goose",
          pictureAssetName: "g_word_goose",
          pictureLabel: "Goose",
        },
        {
          words: [
            "This",
            "gift",
            "has",
            "a",
            "gold",
            "bow",
          ],
          focusWord: "this",
          pictureAssetName: "g_word_gift",
          pictureLabel: "Gift",
        },
      ],
      focusAssets: {
        goat: "g_word_goat",
        goose: "g_word_goose",
        this: "g_word_gift",
      },
    },
    traceG: {
      engine: "guidedTrace",
      title: "Trace G and g",
      prompt: "Trace G and g",
      background: "g_game_golden_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "G",
          prompts: [],
          strokes: [
            [{ x: 0.76, y: 0.27 }, { x: 0.66, y: 0.16 }, { x: 0.49, y: 0.12 }, { x: 0.33, y: 0.18 }, { x: 0.23, y: 0.34 }, { x: 0.21, y: 0.53 }, { x: 0.27, y: 0.72 }, { x: 0.42, y: 0.84 }, { x: 0.6, y: 0.86 }, { x: 0.75, y: 0.76 }, { x: 0.76, y: 0.58 }, { x: 0.6, y: 0.58 }],
          ],
          strokeCount: 1,
        },
        lowercase: {
          glyph: "g",
          prompts: [],
          strokes: [
            [{ x: 0.64, y: 0.39 }, { x: 0.54, y: 0.33 }, { x: 0.4, y: 0.35 }, { x: 0.3, y: 0.46 }, { x: 0.3, y: 0.61 }, { x: 0.39, y: 0.72 }, { x: 0.53, y: 0.73 }, { x: 0.63, y: 0.63 }, { x: 0.64, y: 0.48 }, { x: 0.64, y: 0.39 }, { x: 0.66, y: 0.55 }, { x: 0.66, y: 0.74 }, { x: 0.62, y: 0.88 }, { x: 0.52, y: 0.94 }, { x: 0.41, y: 0.91 }],
          ],
          strokeCount: 1,
        },
      }
    },
  },
  H: {
    hilltopDiscovery: {
      engine: "discovery",
      title: "Hilltop H Discovery",
      prompt: "Tap each pod. Listen for H like hat.",
      background: "i_game_short_i_sort_meadow_bg",
      items: [
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "initialH" },
        { word: "hen", assetName: "asf_cutout_chicken", isTarget: true, startingSound: "initialH" },
        { word: "hippo", assetName: "h_word_hippo", isTarget: true, startingSound: "initialH" },
        { word: "horse", assetName: "asf_cutout_horse", isTarget: true, startingSound: "initialH" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "initialH" },
        { word: "hammer", assetName: "h_word_hammer", isTarget: true, startingSound: "initialH" },
      ],
    },
    initialHSort: {
      engine: "soundSort",
      title: "H as in Hat",
      prompt: "Drag by first sound: H like hat, or another sound.",
      background: "e_game_e_sound_ferry_bg",
      zones: {
        target: {
          title: "Starts with H",
        },
        other: {
          title: "Not H",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "initialH" },
        { word: "hen", assetName: "asf_cutout_chicken", isTarget: true, startingSound: "initialH" },
        { word: "hippo", assetName: "h_word_hippo", isTarget: true, startingSound: "initialH" },
        { word: "horse", assetName: "asf_cutout_horse", isTarget: true, startingSound: "initialH" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "initialH" },
        { word: "hammer", assetName: "h_word_hammer", isTarget: true, startingSound: "initialH" },
        { word: "hand", assetName: "h_word_hand", isTarget: true, startingSound: "initialH" },
        { word: "heart", assetName: "h_word_heart", isTarget: true, startingSound: "initialH" },
        { word: "honey", assetName: "h_word_honey", isTarget: true, startingSound: "initialH" },
        { word: "helicopter", assetName: "h_word_helicopter", isTarget: true, startingSound: "initialH" },
      ],
      distractorItems: [
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "ball", assetName: "a_word_ball", isTarget: false, startingSound: "other" },
        { word: "bus", assetName: "a_word_bus", isTarget: false, startingSound: "other" },
        { word: "egg", assetName: "a_word_egg", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "a_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "tree", assetName: "a_word_tree", isTarget: false, startingSound: "other" },
      ],
    },
    letterHunt: {
      engine: "letterHunt",
      title: "Hidden Hollow H Hunt",
      prompt: "Tap every uppercase H and lowercase h.",
      background: "e_game_e_hunt_firefly_forest_bg",
      tokenSequence: [
        "H",
        "h",
        "A",
        "H",
        "C",
        "h",
        "D",
        "H",
        "e",
        "h",
        "K",
        "o",
      ],
      layoutPoints: [
        [0.16, 0.3], [0.48, 0.28], [0.82, 0.32], [0.3, 0.46], [0.7, 0.45],
        [0.11, 0.6], [0.48, 0.62], [0.87, 0.58], [0.23, 0.76], [0.62, 0.77],
        [0.84, 0.81], [0.43, 0.88],
      ],
      distractorCount: 6,
      targetCopies: 6,
      targets: [
        "H",
        "h",
      ],
      distractors: [
        "A",
        "C",
        "D",
        "e",
        "K",
        "o",
      ]
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "Happy Harbor Picture Match",
      prompt: "Listen, then tap the picture I name.",
      background: "d_game_dolphin_dock_match_bg",
      items: [
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "initialH" },
        { word: "hen", assetName: "asf_cutout_chicken", isTarget: true, startingSound: "initialH" },
        { word: "hippo", assetName: "h_word_hippo", isTarget: true, startingSound: "initialH" },
        { word: "horse", assetName: "asf_cutout_horse", isTarget: true, startingSound: "initialH" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "initialH" },
        { word: "hammer", assetName: "h_word_hammer", isTarget: true, startingSound: "initialH" },
        { word: "hand", assetName: "h_word_hand", isTarget: true, startingSound: "initialH" },
        { word: "heart", assetName: "h_word_heart", isTarget: true, startingSound: "initialH" },
        { word: "honey", assetName: "h_word_honey", isTarget: true, startingSound: "initialH" },
      ],
    },
    honeybeeHelp: {
      engine: "genericTap",
      title: "Help the Honeybees",
      prompt: "Tap pictures that begin with H like hat.",
      background: "i_game_insect_indoor_garden_bg",
      items: [
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "initialH" },
        { word: "hen", assetName: "asf_cutout_chicken", isTarget: true, startingSound: "initialH" },
        { word: "hippo", assetName: "h_word_hippo", isTarget: true, startingSound: "initialH" },
        { word: "horse", assetName: "asf_cutout_horse", isTarget: true, startingSound: "initialH" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "initialH" },
        { word: "hammer", assetName: "h_word_hammer", isTarget: true, startingSound: "initialH" },
        { word: "hand", assetName: "h_word_hand", isTarget: true, startingSound: "initialH" },
        { word: "heart", assetName: "h_word_heart", isTarget: true, startingSound: "initialH" },
        { word: "honey", assetName: "h_word_honey", isTarget: true, startingSound: "initialH" },
        { word: "helicopter", assetName: "h_word_helicopter", isTarget: true, startingSound: "initialH" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "ball", assetName: "a_word_ball", isTarget: false, startingSound: "other" },
        { word: "bus", assetName: "a_word_bus", isTarget: false, startingSound: "other" },
        { word: "egg", assetName: "a_word_egg", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "a_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "tree", assetName: "a_word_tree", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceBuilder",
      title: "Build H Sentences",
      prompt: "Tap the words in sentence order.",
      background: "g_game_garden_sentence_bg",
      roundSize: 3,
      sentences: [
        {
          words: [
            "A",
            "hen",
            "can",
            "hop",
          ],
          focusWord: "hen",
          pictureAssetName: "asf_cutout_chicken",
          pictureLabel: "Hen",
        },
        {
          words: [
            "The",
            "horse",
            "wears",
            "a",
            "hat",
          ],
          focusWord: "horse",
          pictureAssetName: "asf_cutout_horse",
          pictureLabel: "Horse",
        },
        {
          words: [
            "I",
            "see",
            "a",
            "house",
          ],
          focusWord: "house",
          pictureAssetName: "h_word_house",
          pictureLabel: "House",
        },
      ],
      focusAssets: {
        hen: "asf_cutout_chicken",
        horse: "asf_cutout_horse",
        house: "h_word_house",
      },
    },
    traceH: {
      engine: "guidedTrace",
      title: "Trace H and h",
      prompt: "Trace H and h",
      background: "e_game_trace_art_studio_bg",
      cases: {
        uppercase: {
          glyph: "H",
          prompts: [],
          strokes: [
            [{ x: 0.3, y: 0.17 }, { x: 0.3, y: 0.84 }],
            [{ x: 0.7, y: 0.17 }, { x: 0.7, y: 0.84 }],
            [{ x: 0.3, y: 0.51 }, { x: 0.7, y: 0.51 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "h",
          prompts: [],
          strokes: [
            [{ x: 0.35, y: 0.16 }, { x: 0.35, y: 0.84 }],
            [{ x: 0.35, y: 0.5 }, { x: 0.43, y: 0.4 }, { x: 0.55, y: 0.38 }, { x: 0.65, y: 0.45 }, { x: 0.67, y: 0.58 }, { x: 0.67, y: 0.84 }],
          ],
          strokeCount: 2,
        },
      }
    },
  },
  I: {
    insectDiscovery: {
      engine: "discovery",
      title: "Insect Garden Discovery",
      prompt: "Tap each glowing window. Meet words that start with I.",
      background: "i_game_insect_indoor_garden_bg",
      items: [
        { word: "insect", assetName: "i_word_insect", isTarget: true, startingSound: "shortI" },
        { word: "igloo", assetName: "i_word_igloo", isTarget: true, startingSound: "shortI" },
        { word: "ink", assetName: "i_word_ink", isTarget: true, startingSound: "shortI" },
        { word: "ice", assetName: "i_word_ice", isTarget: true, startingSound: "longI" },
        { word: "island", assetName: "i_word_island", isTarget: true, startingSound: "longI" },
        { word: "ivy", assetName: "i_word_ivy", isTarget: true, startingSound: "longI" },
      ],
    },
    shortISort: {
      engine: "soundSort",
      title: "Starts with I?",
      prompt: "Drag each picture to Starts with I or Not I.",
      background: "i_game_short_i_sort_meadow_bg",
      zones: {
        target: {
          title: "Starts with I",
        },
        other: {
          title: "Not I",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "insect", assetName: "i_word_insect", isTarget: true, startingSound: "shortI" },
        { word: "igloo", assetName: "i_word_igloo", isTarget: true, startingSound: "shortI" },
        { word: "ink", assetName: "i_word_ink", isTarget: true, startingSound: "shortI" },
        { word: "ice", assetName: "i_word_ice", isTarget: true, startingSound: "longI" },
        { word: "island", assetName: "i_word_island", isTarget: true, startingSound: "longI" },
        { word: "ivy", assetName: "i_word_ivy", isTarget: true, startingSound: "longI" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherLetter" },
        { word: "ball", assetName: "a_word_ball", isTarget: true, startingSound: "otherLetter" },
        { word: "dog", assetName: "a_word_dog", isTarget: true, startingSound: "otherLetter" },
        { word: "fish", assetName: "a_word_fish", isTarget: true, startingSound: "otherLetter" },
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "otherLetter" },
      ],
      distractorItems: [],
    },
    letterHunt: {
      engine: "letterHunt",
      title: "Ink Lantern I Hunt",
      prompt: "Tap every uppercase I and lowercase i.",
      background: "i_game_ink_lantern_hunt_bg",
      targets: [
        "I",
        "i",
      ],
      targetCopies: 6,
      distractors: [
        "F",
        "B",
        "P",
        "C",
        "G",
        "L",
        "R",
        "S",
        "U",
        "M",
        "N",
        "A",
        "f",
        "b",
        "p",
        "o",
        "c",
        "a",
        "d",
        "g",
      ],
      distractorCount: 12,
      layoutPoints: [
        [0.12, 0.22], [0.32, 0.2], [0.53, 0.24], [0.78, 0.2], [0.9, 0.33],
        [0.15, 0.4], [0.4, 0.38], [0.66, 0.42], [0.84, 0.5], [0.1, 0.57],
        [0.31, 0.6], [0.54, 0.56], [0.72, 0.66], [0.91, 0.7], [0.16, 0.78],
        [0.38, 0.83], [0.62, 0.77], [0.82, 0.85],
      ],
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "Island Picture Match",
      prompt: "Listen, then tap the picture I name.",
      background: "i_game_island_picture_match_bg",
      items: [
        { word: "insect", assetName: "i_word_insect", isTarget: true, startingSound: "shortI" },
        { word: "igloo", assetName: "i_word_igloo", isTarget: true, startingSound: "shortI" },
        { word: "ink", assetName: "i_word_ink", isTarget: true, startingSound: "shortI" },
        { word: "ice", assetName: "i_word_ice", isTarget: true, startingSound: "longI" },
        { word: "island", assetName: "i_word_island", isTarget: true, startingSound: "longI" },
        { word: "ivy", assetName: "i_word_ivy", isTarget: true, startingSound: "longI" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherLetter" },
        { word: "ball", assetName: "a_word_ball", isTarget: true, startingSound: "otherLetter" },
        { word: "dog", assetName: "a_word_dog", isTarget: true, startingSound: "otherLetter" },
      ],
    },
    longIContrast: {
      engine: "pictureMatch",
      title: "I Word Bridge",
      prompt: "Drag the letter I across the bridge to each I picture.",
      background: "i_game_ice_bridge_contrast_bg",
      items: [
        { word: "insect", assetName: "i_word_insect", isTarget: true, startingSound: "shortI" },
        { word: "igloo", assetName: "i_word_igloo", isTarget: true, startingSound: "shortI" },
        { word: "ink", assetName: "i_word_ink", isTarget: true, startingSound: "shortI" },
        { word: "ice", assetName: "i_word_ice", isTarget: true, startingSound: "longI" },
        { word: "island", assetName: "i_word_island", isTarget: true, startingSound: "longI" },
        { word: "ivy", assetName: "i_word_ivy", isTarget: true, startingSound: "longI" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherLetter" },
        { word: "ball", assetName: "a_word_ball", isTarget: true, startingSound: "otherLetter" },
        { word: "dog", assetName: "a_word_dog", isTarget: true, startingSound: "otherLetter" },
      ],
    },
    wordWorkshop: {
      engine: "wordBuilder",
      title: "Imagine an I Word",
      prompt: "Listen to the picture name, then build it with the mixed letter blocks.",
      background: "i_game_idea_workshop_bg",
      puzzles: [
        {
          word: "ink",
          assetName: "i_word_ink",
          letters: [
            "I",
            "N",
            "K",
          ],
          soundNote: "Ink begins with I.",
          shuffleSeed: 11,
        },
        {
          word: "igloo",
          assetName: "i_word_igloo",
          letters: [
            "I",
            "G",
            "L",
            "O",
            "O",
          ],
          soundNote: "Igloo begins with I.",
          shuffleSeed: 23,
        },
        {
          word: "ice",
          assetName: "i_word_ice",
          letters: [
            "I",
            "C",
            "E",
          ],
          soundNote: "Ice begins with I.",
          shuffleSeed: 37,
        },
      ],
    },
    traceI: {
      engine: "guidedTrace",
      title: "Trace I and i",
      prompt: "Trace I and i",
      background: "i_game_illustration_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "I",
          prompts: [],
          strokes: [
            [{ x: 0.28, y: 0.16 }, { x: 0.72, y: 0.16 }],
            [{ x: 0.5, y: 0.16 }, { x: 0.5, y: 0.84 }],
            [{ x: 0.28, y: 0.84 }, { x: 0.72, y: 0.84 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "i",
          prompts: [],
          strokes: [
            [{ x: 0.5, y: 0.4 }, { x: 0.5, y: 0.82 }],
            [{ x: 0.5, y: 0.255 }, { x: 0.5001, y: 0.255 }],
          ],
          strokeCount: 2,
        },
      }
    },
  },
  J: {
    jewelDiscovery: {
      engine: "discovery",
      title: "Jewel Garden Discovery",
      prompt: "Tap each pod. Hear J as in jam.",
      background: "j_game_jewel_garden_discovery_bg",
      items: [
        { word: "jam", assetName: "j_word_jam", isTarget: true, startingSound: "initialJ" },
        { word: "jet", assetName: "j_word_jet", isTarget: true, startingSound: "initialJ" },
        { word: "juice", assetName: "j_word_juice", isTarget: true, startingSound: "initialJ" },
        { word: "jelly", assetName: "j_word_jelly", isTarget: true, startingSound: "initialJ" },
        { word: "jacket", assetName: "j_word_jacket", isTarget: true, startingSound: "initialJ" },
        { word: "jewel", assetName: "j_word_jewel", isTarget: true, startingSound: "initialJ" },
      ],
    },
    initialSoundSort: {
      engine: "soundSort",
      title: "J Sound Sort",
      prompt: "Drag by first sound: other, or J as in jam.",
      background: "g_game_garden_gate_sort_bg",
      zones: {
        target: {
          title: "Starts with J",
        },
        other: {
          title: "Not J",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "jam", assetName: "j_word_jam", isTarget: true, startingSound: "initialJ" },
        { word: "jet", assetName: "j_word_jet", isTarget: true, startingSound: "initialJ" },
        { word: "juice", assetName: "j_word_juice", isTarget: true, startingSound: "initialJ" },
        { word: "jelly", assetName: "j_word_jelly", isTarget: true, startingSound: "initialJ" },
        { word: "jacket", assetName: "j_word_jacket", isTarget: true, startingSound: "initialJ" },
        { word: "jewel", assetName: "j_word_jewel", isTarget: true, startingSound: "initialJ" },
        { word: "jug", assetName: "j_word_jug", isTarget: true, startingSound: "initialJ" },
        { word: "jeans", assetName: "j_word_jeans", isTarget: true, startingSound: "initialJ" },
        { word: "jigsaw", assetName: "j_word_jigsaw", isTarget: true, startingSound: "initialJ" },
        { word: "jellyfish", assetName: "j_word_jellyfish", isTarget: true, startingSound: "initialJ" },
      ],
      distractorItems: [
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "ball", assetName: "a_word_ball", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "a_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "a_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "tree", assetName: "a_word_tree", isTarget: false, startingSound: "other" },
      ],
    },
    letterHunt: {
      engine: "letterHunt",
      title: "Jungle J Hunt",
      prompt: "Find every uppercase J and lowercase j.",
      background: "j_game_jungle_letter_hunt_bg",
      tokenSequence: [
        "J",
        "j",
        "L",
        "i",
        "J",
        "t",
        "j",
        "U",
        "F",
        "J",
        "y",
        "j",
      ],
      distractorCount: 6,
      targetCopies: 6,
      targets: [
        "J",
        "j",
      ],
      distractors: [
        "L",
        "i",
        "t",
        "U",
        "F",
        "y",
      ]
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "Jam Gazebo Match",
      prompt: "Listen, then choose the named picture.",
      background: "g_game_gazebo_picture_match_bg",
      items: [
        { word: "jam", assetName: "j_word_jam", isTarget: true, startingSound: "initialJ" },
        { word: "jet", assetName: "j_word_jet", isTarget: true, startingSound: "initialJ" },
        { word: "juice", assetName: "j_word_juice", isTarget: true, startingSound: "initialJ" },
        { word: "jelly", assetName: "j_word_jelly", isTarget: true, startingSound: "initialJ" },
        { word: "jacket", assetName: "j_word_jacket", isTarget: true, startingSound: "initialJ" },
        { word: "jewel", assetName: "j_word_jewel", isTarget: true, startingSound: "initialJ" },
        { word: "jug", assetName: "j_word_jug", isTarget: true, startingSound: "initialJ" },
        { word: "jeans", assetName: "j_word_jeans", isTarget: true, startingSound: "initialJ" },
        { word: "jigsaw", assetName: "j_word_jigsaw", isTarget: true, startingSound: "initialJ" },
      ],
    },
    jungleJourney: {
      engine: "catchFalling",
      title: "Jungle J Journey",
      prompt: "Collect pictures that begin with J as in jam.",
      background: "j_game_jungle_journey_gather_bg",
      targetItems: [
        { word: "jam", assetName: "j_word_jam", isTarget: true, startingSound: "initialJ" },
        { word: "jet", assetName: "j_word_jet", isTarget: true, startingSound: "initialJ" },
        { word: "juice", assetName: "j_word_juice", isTarget: true, startingSound: "initialJ" },
        { word: "jelly", assetName: "j_word_jelly", isTarget: true, startingSound: "initialJ" },
        { word: "jacket", assetName: "j_word_jacket", isTarget: true, startingSound: "initialJ" },
        { word: "jewel", assetName: "j_word_jewel", isTarget: true, startingSound: "initialJ" },
        { word: "jug", assetName: "j_word_jug", isTarget: true, startingSound: "initialJ" },
        { word: "jeans", assetName: "j_word_jeans", isTarget: true, startingSound: "initialJ" },
        { word: "jigsaw", assetName: "j_word_jigsaw", isTarget: true, startingSound: "initialJ" },
        { word: "jellyfish", assetName: "j_word_jellyfish", isTarget: true, startingSound: "initialJ" },
      ],
      distractorItems: [
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "ball", assetName: "a_word_ball", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "a_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "a_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "tree", assetName: "a_word_tree", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceBuilder",
      title: "Build a J Sentence",
      prompt: "Tap the words in sentence order.",
      background: "g_game_garden_sentence_bg",
      roundSize: 3,
      sentences: [
        {
          words: [
            "I",
            "see",
            "a",
            "jet",
          ],
          focusWord: "jet",
          pictureAssetName: "j_word_jet",
          pictureLabel: "Jet",
        },
        {
          words: [
            "The",
            "jar",
            "has",
            "jam",
          ],
          focusWord: "jar",
          pictureAssetName: "j_word_jam",
          pictureLabel: "Jam jar",
        },
        {
          words: [
            "My",
            "jacket",
            "is",
            "yellow",
          ],
          focusWord: "my",
          pictureAssetName: "j_word_jacket",
          pictureLabel: "Yellow jacket",
        },
      ],
      focusAssets: {
        jet: "j_word_jet",
        jar: "j_word_jam",
        my: "j_word_jacket",
      },
    },
    traceJ: {
      engine: "guidedTrace",
      title: "Trace J and j",
      prompt: "Start at each number and follow the dotted path.",
      background: "g_game_golden_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "J",
          prompts: [],
          strokes: [
            [{ x: 0.16, y: 0.18 }, { x: 0.5, y: 0.18 }, { x: 0.84, y: 0.18 }],
            [{ x: 0.62, y: 0.18 }, { x: 0.62, y: 0.63 }, { x: 0.6, y: 0.75 }, { x: 0.52, y: 0.84 }, { x: 0.4, y: 0.87 }, { x: 0.3, y: 0.82 }, { x: 0.25, y: 0.73 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "j",
          prompts: [],
          strokes: [
            [{ x: 0.58, y: 0.34 }, { x: 0.58, y: 0.69 }, { x: 0.56, y: 0.81 }, { x: 0.48, y: 0.89 }, { x: 0.37, y: 0.91 }, { x: 0.29, y: 0.86 }],
            [{ x: 0.58, y: 0.2 }, { x: 0.5801, y: 0.2 }],
          ],
          strokeCount: 2,
        },
      }
    },
  },
  K: {
    keyGardenDiscovery: {
      engine: "discovery",
      title: "Key Garden Discovery",
      prompt: "Key Garden Discovery",
      background: "g_game_garden_gate_sort_bg",
      items: [
        { word: "kite", assetName: "k_word_kite", isTarget: true, startingSound: "initialK" },
        { word: "key", assetName: "k_word_key", isTarget: true, startingSound: "initialK" },
        { word: "kitten", assetName: "ch_kitten", isTarget: true, startingSound: "initialK" },
        { word: "kangaroo", assetName: "k_word_kangaroo", isTarget: true, startingSound: "initialK" },
        { word: "koala", assetName: "k_word_koala", isTarget: true, startingSound: "initialK" },
        { word: "kiwi", assetName: "k_word_kiwi", isTarget: true, startingSound: "initialK" },
      ],
    },
    initialSoundSort: {
      engine: "callSequence",
      title: "Kite Call Sequence",
      prompt: "Kite Call Sequence",
      background: "b_game_sort_blueberry_meadow_bg",
      swiftCase: "kiteCallSequence",
      rounds: [
        {
          id: "two-kite-key",
          sequence: [
            "kite",
            "key",
          ],
          choices: [
            "kite",
            "key",
            "koala",
            "kiwi",
          ],
        },
        {
          id: "two-kitten-kiwi",
          sequence: [
            "kitten",
            "kiwi",
          ],
          choices: [
            "kitten",
            "kiwi",
            "key",
            "kite",
          ],
        },
        {
          id: "three-koala-key-kite",
          sequence: [
            "koala",
            "key",
            "kite",
          ],
          choices: [
            "koala",
            "key",
            "kite",
            "kitten",
          ],
        },
      ],
      items: [
        { word: "kite", assetName: "k_word_kite", isTarget: true, startingSound: "initialK" },
        { word: "key", assetName: "k_word_key", isTarget: true, startingSound: "initialK" },
        { word: "kitten", assetName: "ch_kitten", isTarget: true, startingSound: "initialK" },
        { word: "kangaroo", assetName: "k_word_kangaroo", isTarget: true, startingSound: "initialK" },
        { word: "koala", assetName: "k_word_koala", isTarget: true, startingSound: "initialK" },
        { word: "kiwi", assetName: "k_word_kiwi", isTarget: true, startingSound: "initialK" },
        { word: "ketchup", assetName: "k_word_ketchup", isTarget: true, startingSound: "initialK" },
        { word: "keyboard", assetName: "k_word_keyboard", isTarget: true, startingSound: "initialK" },
      ],
    },
    letterHunt: {
      engine: "strokeAssembly",
      title: "Build K",
      prompt: "Build K",
      background: "j_game_jungle_letter_hunt_bg",
      swiftCase: "buildK",
      notes: "Piece/target layout not fully extractable from Swift (may be code-drawn).",
    },
    pictureMatch: {
      engine: "memoryPair",
      title: "Key Memory",
      prompt: "Key Memory",
      background: "g_game_gazebo_picture_match_bg",
      swiftCase: "keyMemory",
      items: [
        { word: "kite", assetName: "k_word_kite", isTarget: true, startingSound: "initialK" },
        { word: "key", assetName: "k_word_key", isTarget: true, startingSound: "initialK" },
        { word: "kitten", assetName: "ch_kitten", isTarget: true, startingSound: "initialK" },
        { word: "kangaroo", assetName: "k_word_kangaroo", isTarget: true, startingSound: "initialK" },
        { word: "koala", assetName: "k_word_koala", isTarget: true, startingSound: "initialK" },
        { word: "kiwi", assetName: "k_word_kiwi", isTarget: true, startingSound: "initialK" },
        { word: "ketchup", assetName: "k_word_ketchup", isTarget: true, startingSound: "initialK" },
        { word: "keyboard", assetName: "k_word_keyboard", isTarget: true, startingSound: "initialK" },
      ],
    },
    kiteTrail: {
      engine: "genericTap",
      title: "K Word Steps",
      prompt: "K Word Steps",
      background: "j_game_jungle_journey_gather_bg",
      swiftCase: "syllableSteps",
      rounds: [
        {
          word: "key",
          spokenParts: [
            "key",
          ],
        },
        {
          word: "kite",
          spokenParts: [
            "kite",
          ],
        },
        {
          word: "kitten",
          spokenParts: [
            "kit",
            "ten",
          ],
        },
        {
          word: "keyboard",
          spokenParts: [
            "key",
            "board",
          ],
        },
        {
          word: "koala",
          spokenParts: [
            "ko",
            "a",
            "la",
          ],
        },
        {
          word: "kangaroo",
          spokenParts: [
            "kan",
            "ga",
            "roo",
          ],
        },
      ],
    },
    sentenceBuilder: {
      engine: "wordBuilder",
      title: "K Word Wheel",
      prompt: "K Word Wheel",
      background: "f_game_forest_story_sentence_bg",
      swiftCase: "wordWheel",
      endings: [
        "ite",
        "ey",
        "itten",
        "oala",
        "iwi",
      ],
      rounds: [
        {
          word: "kite",
          ending: "ite",
          pictureChoices: [
            "kite",
            "key",
            "kiwi",
          ],
        },
        {
          word: "key",
          ending: "ey",
          pictureChoices: [
            "koala",
            "key",
            "kitten",
          ],
        },
        {
          word: "kitten",
          ending: "itten",
          pictureChoices: [
            "kiwi",
            "kite",
            "kitten",
          ],
        },
        {
          word: "koala",
          ending: "oala",
          pictureChoices: [
            "koala",
            "key",
            "kite",
          ],
        },
        {
          word: "kiwi",
          ending: "iwi",
          pictureChoices: [
            "kitten",
            "kiwi",
            "koala",
          ],
        },
      ],
    },
    traceK: {
      engine: "guidedTrace",
      title: "Trace K and k",
      prompt: "Trace K and k",
      background: "i_game_illustration_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "K",
          prompts: [],
          strokes: [
            [{ x: 0.3, y: 0.16 }, { x: 0.3, y: 0.5 }, { x: 0.3, y: 0.86 }],
            [{ x: 0.32, y: 0.51 }, { x: 0.52, y: 0.34 }, { x: 0.73, y: 0.16 }],
            [{ x: 0.32, y: 0.51 }, { x: 0.52, y: 0.68 }, { x: 0.74, y: 0.86 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "k",
          prompts: [],
          strokes: [
            [{ x: 0.35, y: 0.17 }, { x: 0.35, y: 0.52 }, { x: 0.35, y: 0.86 }],
            [{ x: 0.37, y: 0.57 }, { x: 0.52, y: 0.47 }, { x: 0.68, y: 0.35 }],
            [{ x: 0.47, y: 0.5 }, { x: 0.59, y: 0.68 }, { x: 0.72, y: 0.85 }],
          ],
          strokeCount: 3,
        },
      }
    },
  },
  L: {
    lanternDiscovery: {
      engine: "discovery",
      title: "Lantern Grove Discovery",
      prompt: "Lantern Grove Discovery",
      background: "i_game_ink_lantern_hunt_bg",
      items: [
        { word: "leaf", assetName: "ch_leaf", isTarget: true, startingSound: "initialL" },
        { word: "lion", assetName: "l_word_lion", isTarget: true, startingSound: "initialL" },
        { word: "lemon", assetName: "l_word_lemon", isTarget: true, startingSound: "initialL" },
        { word: "ladder", assetName: "l_word_ladder", isTarget: true, startingSound: "initialL" },
        { word: "ladybug", assetName: "l_word_ladybug", isTarget: true, startingSound: "initialL" },
        { word: "lily pad", assetName: "ch_lilypad", isTarget: true, startingSound: "initialL" },
      ],
    },
    initialSoundSort: {
      engine: "soundSort",
      title: "L Sound Sort",
      prompt: "L Sound Sort",
      background: "b_game_sort_blueberry_meadow_bg",
      zones: {
        target: {
          title: "Starts with L",
        },
        other: {
          title: "Not L",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "leaf", assetName: "ch_leaf", isTarget: true, startingSound: "initialL" },
        { word: "lion", assetName: "l_word_lion", isTarget: true, startingSound: "initialL" },
        { word: "lemon", assetName: "l_word_lemon", isTarget: true, startingSound: "initialL" },
        { word: "ladder", assetName: "l_word_ladder", isTarget: true, startingSound: "initialL" },
        { word: "ladybug", assetName: "l_word_ladybug", isTarget: true, startingSound: "initialL" },
        { word: "lily pad", assetName: "ch_lilypad", isTarget: true, startingSound: "initialL" },
        { word: "light", assetName: "ch_light_green", isTarget: true, startingSound: "initialL" },
      ],
      distractorItems: [
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    letterHunt: {
      engine: "letterHunt",
      title: "Lagoon L Hunt",
      prompt: "Lagoon L Hunt",
      background: "j_game_jungle_letter_hunt_bg",
      tokenSequence: [
        "L",
        "A",
        "l",
        "T",
        "L",
        "i",
        "l",
        "E",
        "L",
        "j",
        "l",
        "F",
      ],
      distractorCount: 6,
      targetCopies: 6,
      targets: [
        "L",
        "l",
      ],
      distractors: [
        "A",
        "T",
        "i",
        "E",
        "j",
        "F",
      ]
    },
    pictureMatch: {
      engine: "soundPairs",
      title: "L Sound-Pair Detective",
      prompt: "L Sound-Pair Detective",
      background: "g_game_gazebo_picture_match_bg",
      pairs: [
        {
          id: "leaf-lion",
          firstRef: "LWordCatalog.initialLWords[0]",
          secondRef: "LWordCatalog.initialLWords[1]",
          bothTarget: true,
        },
        {
          id: "lemon-dog",
          firstRef: "LWordCatalog.initialLWords[2]",
          secondRef: "LWordCatalog.distractorWords[1]",
          bothTarget: false,
        },
        {
          id: "ladder-ladybug",
          firstRef: "LWordCatalog.initialLWords[3]",
          secondRef: "LWordCatalog.initialLWords[4]",
          bothTarget: true,
        },
        {
          id: "light-moon",
          firstRef: "LWordCatalog.initialLWords[6]",
          secondRef: "LWordCatalog.distractorWords[3]",
          bothTarget: false,
        },
        {
          id: "lily-fish",
          firstRef: "LWordCatalog.initialLWords[5]",
          secondRef: "LWordCatalog.distractorWords[2]",
          bothTarget: false,
        },
      ],
      wordBank: [
        { word: "leaf", assetName: "ch_leaf", isTarget: true, startingSound: "initialL" },
        { word: "lion", assetName: "l_word_lion", isTarget: true, startingSound: "initialL" },
        { word: "lemon", assetName: "l_word_lemon", isTarget: true, startingSound: "initialL" },
        { word: "ladder", assetName: "l_word_ladder", isTarget: true, startingSound: "initialL" },
        { word: "ladybug", assetName: "l_word_ladybug", isTarget: true, startingSound: "initialL" },
        { word: "lily pad", assetName: "ch_lilypad", isTarget: true, startingSound: "initialL" },
        { word: "light", assetName: "ch_light_green", isTarget: true, startingSound: "initialL" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    ladybugTrail: {
      engine: "strokeAssembly",
      title: "Build L with Lines",
      prompt: "Build L with Lines",
      background: "j_game_jungle_journey_gather_bg",
      pieces: [
        {
          id: "uppercase-across",
          x: 13.0,
          y: 75.0,
        },
        {
          id: "lowercase-down",
          x: 0.0,
          y: 0.0,
        },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceMeaning",
      title: "Sentence Meaning Garden",
      prompt: "Sentence Meaning Garden",
      background: "f_game_forest_story_sentence_bg",
      prompts: [
        {
          id: "see-lion",
          visibleFrame: "I see a blank.",
          spokenInstruction: "I see a lion.",
          answerRef: "LWordCatalog.initialLWords",
        },
        {
          id: "yellow-lemon",
          visibleFrame: "The blank is yellow.",
          spokenInstruction: "The lemon is yellow.",
          answerRef: "LWordCatalog.initialLWords",
        },
        {
          id: "spotted-ladybug",
          visibleFrame: "The blank has spots.",
          spokenInstruction: "The ladybug has spots.",
          answerRef: "LWordCatalog.initialLWords",
        },
      ],
      wordBank: [
        { word: "leaf", assetName: "ch_leaf", isTarget: true, startingSound: "initialL" },
        { word: "lion", assetName: "l_word_lion", isTarget: true, startingSound: "initialL" },
        { word: "lemon", assetName: "l_word_lemon", isTarget: true, startingSound: "initialL" },
        { word: "ladder", assetName: "l_word_ladder", isTarget: true, startingSound: "initialL" },
        { word: "ladybug", assetName: "l_word_ladybug", isTarget: true, startingSound: "initialL" },
        { word: "lily pad", assetName: "ch_lilypad", isTarget: true, startingSound: "initialL" },
        { word: "light", assetName: "ch_light_green", isTarget: true, startingSound: "initialL" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "a_word_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    traceL: {
      engine: "guidedTrace",
      title: "Trace L and l",
      prompt: "Trace L and l",
      background: "i_game_illustration_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "L",
          prompts: [],
          strokes: [
            [{ x: 0.38, y: 0.18 }, { x: 0.38, y: 0.83 }],
            [{ x: 0.38, y: 0.83 }, { x: 0.7, y: 0.83 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "l",
          prompts: [],
          strokes: [
            [{ x: 0.5, y: 0.18 }, { x: 0.5, y: 0.83 }],
          ],
          strokeCount: 1,
        },
      }
    },
  },
  M: {
    soundMixer: {
      engine: "genericTap",
      title: "Make the M Sound",
      prompt: "Make the M Sound",
      background: "g_game_greenhouse_discovery_bg",
      items: [
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "initialM" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "initialM" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "initialM" },
        { word: "map", assetName: "m_word_map", isTarget: true, startingSound: "initialM" },
        { word: "milk", assetName: "ch_grocery_milk", isTarget: true, startingSound: "initialM" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "initialM" },
        { word: "mitten", assetName: "m_word_mitten", isTarget: true, startingSound: "initialM" },
        { word: "mango", assetName: "m_word_mango", isTarget: true, startingSound: "initialM" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    initialSoundSort: {
      engine: "soundSort",
      title: "M Sound Sort",
      prompt: "M Sound Sort",
      background: "i_game_short_i_sort_meadow_bg",
      zones: {
        target: {
          title: "Starts with M",
        },
        other: {
          title: "Not M",
        },
      },
      roundTargetCount: 5,
      roundDistractorCount: 5,
      targetItems: [
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "initialM" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "initialM" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "initialM" },
        { word: "map", assetName: "m_word_map", isTarget: true, startingSound: "initialM" },
        { word: "milk", assetName: "ch_grocery_milk", isTarget: true, startingSound: "initialM" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "initialM" },
        { word: "mitten", assetName: "m_word_mitten", isTarget: true, startingSound: "initialM" },
        { word: "mango", assetName: "m_word_mango", isTarget: true, startingSound: "initialM" },
      ],
      distractorItems: [
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    casePairing: {
      engine: "genericTap",
      title: "M Case Partners",
      prompt: "M Case Partners",
      background: "j_game_jungle_letter_hunt_bg",
      items: [
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "initialM" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "initialM" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "initialM" },
        { word: "map", assetName: "m_word_map", isTarget: true, startingSound: "initialM" },
        { word: "milk", assetName: "ch_grocery_milk", isTarget: true, startingSound: "initialM" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "initialM" },
        { word: "mitten", assetName: "m_word_mitten", isTarget: true, startingSound: "initialM" },
        { word: "mango", assetName: "m_word_mango", isTarget: true, startingSound: "initialM" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "M Picture Match",
      prompt: "M Picture Match",
      background: "g_game_gazebo_picture_match_bg",
      items: [
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "initialM" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "initialM" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "initialM" },
        { word: "map", assetName: "m_word_map", isTarget: true, startingSound: "initialM" },
        { word: "milk", assetName: "ch_grocery_milk", isTarget: true, startingSound: "initialM" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "initialM" },
        { word: "mitten", assetName: "m_word_mitten", isTarget: true, startingSound: "initialM" },
        { word: "mango", assetName: "m_word_mango", isTarget: true, startingSound: "initialM" },
      ],
    },
    missingMBuilder: {
      engine: "wordBuilder",
      title: "Finish the M Word",
      prompt: "Finish the M Word",
      background: "e_game_word_workshop_bg",
      choicesByWord: {
        moon: [
          "M",
          "N",
          "W",
        ],
        apple: [
          "M",
          "A",
          "E",
        ],
        map: [
          "T",
          "M",
          "S",
        ],
        dog: [
          "D",
          "M",
          "B",
        ],
        mug: [
          "W",
          "M",
          "N",
        ],
        __default__: [
          "M",
          "F",
          "S",
        ],
      },
      items: [
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "initialM" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "map", assetName: "m_word_map", isTarget: true, startingSound: "initialM" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "initialM" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceBuilder: {
      engine: "sentenceBuilder",
      title: "Build an M Sentence",
      prompt: "Build an M Sentence",
      background: "f_game_forest_story_sentence_bg",
      roundSize: 3,
      sentences: [
        {
          words: [
            "I",
            "see",
            "the",
            "moon",
          ],
          focusWord: "moon",
          pictureAssetName: "f_distractor_moon",
          pictureLabel: "Moon",
        },
        {
          words: [
            "The",
            "mouse",
            "has",
            "a",
            "map",
          ],
          focusWord: "mouse",
          pictureAssetName: "m_word_mouse",
          pictureLabel: "Mouse",
        },
        {
          words: [
            "The",
            "mango",
            "is",
            "by",
            "the",
            "mug",
          ],
          focusWord: "mango",
          pictureAssetName: "m_word_mango",
          pictureLabel: "Mango",
        },
      ],
      focusAssets: {
        moon: "f_distractor_moon",
        mouse: "m_word_mouse",
        mango: "m_word_mango",
      },
    },
    traceM: {
      engine: "guidedTrace",
      title: "Trace M and m",
      prompt: "Trace M and m",
      background: "i_game_illustration_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "M",
          prompts: [],
          strokes: [
            [{ x: 0.2, y: 0.18 }, { x: 0.2, y: 0.82 }],
            [{ x: 0.2, y: 0.18 }, { x: 0.5, y: 0.59 }],
            [{ x: 0.5, y: 0.59 }, { x: 0.8, y: 0.18 }],
            [{ x: 0.8, y: 0.18 }, { x: 0.8, y: 0.82 }],
          ],
          strokeCount: 4,
        },
        lowercase: {
          glyph: "m",
          prompts: [],
          strokes: [
            [{ x: 0.24, y: 0.39 }, { x: 0.24, y: 0.82 }],
          ],
          strokeCount: 1,
        },
      }
    },
  },
  N: {
    soundSlide: {
      engine: "genericTap",
      title: "N Sound Slide",
      prompt: "N Sound Slide",
      background: "n_game_nest_sound_slide_bg",
      items: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
        { word: "dog", assetName: "d_word_dog", isTarget: true, startingSound: "noN" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noN" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noN" },
      ],
    },
    pictureMatch: {
      engine: "pictureMatch",
      title: "N Picture Match",
      prompt: "N Picture Match",
      background: "n_game_nature_picture_match_bg",
      items: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
      ],
    },
    casePairing: {
      engine: "genericTap",
      title: "N Case Partners",
      prompt: "N Case Partners",
      background: "n_game_northern_case_clouds_bg",
      items: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
        { word: "dog", assetName: "d_word_dog", isTarget: true, startingSound: "noN" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noN" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noN" },
      ],
    },
    soundPosition: {
      engine: "soundPosition",
      title: "Where Is the N Sound?",
      prompt: "Where Is the N Sound?",
      background: "n_game_neighborhood_sound_path_bg",
      items: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
        { word: "dog", assetName: "d_word_dog", isTarget: true, startingSound: "noN" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noN" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noN" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "Nose Knows Sound Pairs",
      prompt: "Nose Knows Sound Pairs",
      background: "n_game_nose_knows_garden_bg",
      pairs: [
        {
          id: "nest-nose",
          first: {
            word: "nest",
            assetName: "n_word_nest",
          },
          second: {
            word: "nose",
            assetName: "n_word_nose",
          },
          bothTarget: true,
        },
        {
          id: "net-dog",
          first: {
            word: "net",
            assetName: "n_word_net",
          },
          second: {
            word: "dog",
            assetName: "d_word_dog",
          },
          bothTarget: false,
        },
        {
          id: "noodles-napkin",
          first: {
            word: "noodles",
            assetName: "n_word_noodles",
          },
          second: {
            word: "napkin",
            assetName: "n_word_napkin",
          },
          bothTarget: true,
        },
        {
          id: "notebook-fish",
          first: {
            word: "notebook",
            assetName: "n_word_notebook",
          },
          second: {
            word: "fish",
            assetName: "f_word_fish",
          },
          bothTarget: false,
        },
        {
          id: "nose-net",
          first: {
            word: "nose",
            assetName: "n_word_nose",
          },
          second: {
            word: "net",
            assetName: "n_word_net",
          },
          bothTarget: true,
        },
      ],
      wordBank: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
        { word: "dog", assetName: "d_word_dog", isTarget: true, startingSound: "noN" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noN" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noN" },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "N Sentence Garden",
      prompt: "N Sentence Garden",
      background: "n_game_night_sentence_garden_bg",
      prompts: [
        {
          id: "bird-nest",
          visibleFrame: "The bird sits in the ___.",
          spokenInstruction: "Choose the picture that completes the sentence. The bird sits in the nest.",
          completedSentence: "The bird sits in the nest.",
          answer: "nest",
        },
        {
          id: "wipe-napkin",
          visibleFrame: "I wipe with a ___.",
          spokenInstruction: "Choose the picture that completes the sentence. I wipe with a napkin.",
          completedSentence: "I wipe with a napkin.",
          answer: "napkin",
        },
        {
          id: "write-notebook",
          visibleFrame: "I write in a ___.",
          spokenInstruction: "Choose the picture that completes the sentence. I write in a notebook.",
          completedSentence: "I write in a notebook.",
          answer: "notebook",
        },
        {
          id: "eat-noodles",
          visibleFrame: "I eat the ___.",
          spokenInstruction: "Choose the picture that completes the sentence. I eat the noodles.",
          completedSentence: "I eat the noodles.",
          answer: "noodles",
        },
      ],
      wordBank: [
        { word: "nest", assetName: "n_word_nest", isTarget: true, startingSound: "initialN" },
        { word: "nose", assetName: "n_word_nose", isTarget: true, startingSound: "initialN" },
        { word: "net", assetName: "n_word_net", isTarget: true, startingSound: "initialN" },
        { word: "noodles", assetName: "n_word_noodles", isTarget: true, startingSound: "initialN" },
        { word: "napkin", assetName: "n_word_napkin", isTarget: true, startingSound: "initialN" },
        { word: "notebook", assetName: "n_word_notebook", isTarget: true, startingSound: "initialN" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "finalN" },
        { word: "sun", assetName: "ch_zone_sun", isTarget: true, startingSound: "finalN" },
        { word: "fan", assetName: "f_word_fan", isTarget: true, startingSound: "finalN" },
        { word: "dog", assetName: "d_word_dog", isTarget: true, startingSound: "noN" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noN" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noN" },
      ],
    },
    traceN: {
      engine: "guidedTrace",
      title: "Trace N and n",
      prompt: "Trace N and n",
      background: "n_game_navy_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "N",
          prompts: [],
          strokes: [
            [{ x: 0.27, y: 0.18 }, { x: 0.27, y: 0.82 }],
            [{ x: 0.27, y: 0.82 }, { x: 0.73, y: 0.18 }],
            [{ x: 0.73, y: 0.18 }, { x: 0.73, y: 0.82 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "n",
          prompts: [],
          strokes: [
            [{ x: 0.31, y: 0.34 }, { x: 0.31, y: 0.82 }],
            [{ x: 0.31, y: 0.82 }, { x: 0.32, y: 0.57 }, { x: 0.4, y: 0.39 }, { x: 0.53, y: 0.34 }, { x: 0.65, y: 0.4 }, { x: 0.71, y: 0.55 }, { x: 0.71, y: 0.82 }],
          ],
          strokeCount: 2,
        },
      },
    },
  },
  O: {
    soundSlide: {
      engine: "genericTap",
      title: "Short O Sound Slide",
      prompt: "Short O Sound Slide",
      background: "o_game_sound_tidepool_bg",
      items: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "ostrich", assetName: "o_word_ostrich", isTarget: true, startingSound: "shortO" },
        { word: "octagon", assetName: "o_word_octagon", isTarget: true, startingSound: "shortO" },
        { word: "olive", assetName: "o_word_olive", isTarget: true, startingSound: "shortO" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    casePairing: {
      engine: "genericTap",
      title: "O Case Partners",
      prompt: "O Case Partners",
      background: "o_game_case_porthole_bg",
      items: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "ostrich", assetName: "o_word_ostrich", isTarget: true, startingSound: "shortO" },
        { word: "octagon", assetName: "o_word_octagon", isTarget: true, startingSound: "shortO" },
        { word: "olive", assetName: "o_word_olive", isTarget: true, startingSound: "shortO" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "O Sound Pairs",
      prompt: "O Sound Pairs",
      background: "o_game_sound_pair_cove_bg",
      pairs: [
        {
          id: "octopus-otter",
          firstWord: "octopus",
          secondWord: "otter",
          bothTarget: true,
        },
        {
          id: "ox-ostrich",
          firstWord: "ox",
          secondWord: "ostrich",
          bothTarget: true,
        },
        {
          id: "olive-apple",
          firstWord: "olive",
          secondWord: "apple",
          bothTarget: false,
        },
        {
          id: "octagon-fish",
          firstWord: "octagon",
          secondWord: "fish",
          bothTarget: false,
        },
      ],
      wordBank: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "ostrich", assetName: "o_word_ostrich", isTarget: true, startingSound: "shortO" },
        { word: "octagon", assetName: "o_word_octagon", isTarget: true, startingSound: "shortO" },
        { word: "olive", assetName: "o_word_olive", isTarget: true, startingSound: "shortO" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    echoSequence: {
      engine: "callSequence",
      title: "Ocean Echo Sequence",
      prompt: "Ocean Echo Sequence",
      background: "o_game_echo_shells_bg",
      rounds: [
        {
          id: "two-ocean-friends",
          sequence: [
            "otter",
            "octopus",
          ],
          choices: [
            "octopus",
            "otter",
            "ox",
            "olive",
          ],
        },
        {
          id: "two-shapes",
          sequence: [
            "octagon",
            "olive",
          ],
          choices: [
            "olive",
            "ostrich",
            "octagon",
            "otter",
          ],
        },
        {
          id: "three-o-words",
          sequence: [
            "ox",
            "ostrich",
            "octopus",
          ],
          choices: [
            "octopus",
            "otter",
            "ox",
            "ostrich",
          ],
        },
      ],
      items: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "ostrich", assetName: "o_word_ostrich", isTarget: true, startingSound: "shortO" },
        { word: "octagon", assetName: "o_word_octagon", isTarget: true, startingSound: "shortO" },
        { word: "olive", assetName: "o_word_olive", isTarget: true, startingSound: "shortO" },
      ],
    },
    missingOBuilder: {
      engine: "wordBuilder",
      title: "Finish the O Word",
      prompt: "Finish the O Word",
      background: "o_game_word_workshop_bg",
      items: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "O Sentence Clues",
      prompt: "O Sentence Clues",
      background: "o_game_sentence_lagoon_bg",
      prompts: [
        {
          id: "eight-arms",
          visibleFrame: "The blank has eight arms.",
          spokenInstruction: null,
          completedSentence: "The octopus has eight arms.",
          answer: "octopus",
          choices: [
            "octopus",
            "otter",
            "ox",
          ],
        },
        {
          id: "eight-sides",
          visibleFrame: "The blank has eight sides.",
          spokenInstruction: null,
          completedSentence: "The octagon has eight sides.",
          answer: "octagon",
          choices: [
            "olive",
            "octagon",
            "octopus",
          ],
        },
        {
          id: "soft-fur",
          visibleFrame: "The blank has soft brown fur.",
          spokenInstruction: null,
          completedSentence: "The otter has soft brown fur.",
          answer: "otter",
          choices: [
            "ostrich",
            "ox",
            "otter",
          ],
        },
      ],
      wordBank: [
        { word: "octopus", assetName: "o_word_octopus", isTarget: true, startingSound: "shortO" },
        { word: "otter", assetName: "o_word_otter", isTarget: true, startingSound: "shortO" },
        { word: "ox", assetName: "o_word_ox", isTarget: true, startingSound: "shortO" },
        { word: "ostrich", assetName: "o_word_ostrich", isTarget: true, startingSound: "shortO" },
        { word: "octagon", assetName: "o_word_octagon", isTarget: true, startingSound: "shortO" },
        { word: "olive", assetName: "o_word_olive", isTarget: true, startingSound: "shortO" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    traceO: {
      engine: "guidedTrace",
      title: "Trace O and o",
      prompt: "Trace O and o",
      background: "o_game_trace_art_cove_bg",
      cases: {
        uppercase: {
          glyph: "O",
          prompts: [],
          strokes: [],
          strokeCount: 0,
        },
        lowercase: {
          glyph: "o",
          prompts: [],
          strokes: [],
          strokeCount: 0,
        },
      },
      notes: "Stroke path incomplete or partially extracted from Swift.",
    },
  },
  P: {
    soundPuff: {
      engine: "genericTap",
      title: "P Puff Path",
      prompt: "P Puff Path",
      background: "p_game_puff_path_bg",
      items: [
        { word: "panda", assetName: "pip_course_2d", isTarget: true, startingSound: "initialP" },
        { word: "paper", assetName: "ch_litter_paper", isTarget: true, startingSound: "initialP" },
        { word: "paintbrush", assetName: "p_word_paintbrush", isTarget: true, startingSound: "initialP" },
        { word: "pear", assetName: "p_word_pear", isTarget: true, startingSound: "initialP" },
        { word: "pencil", assetName: "p_word_pencil", isTarget: true, startingSound: "initialP" },
        { word: "pig", assetName: "p_word_pig", isTarget: true, startingSound: "initialP" },
        { word: "puzzle", assetName: "p_word_puzzle", isTarget: true, startingSound: "initialP" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "P Sound Pairs",
      prompt: "P Sound Pairs",
      background: "p_game_sound_pairs_bg",
      pairs: [
        {
          id: "panda-pig",
          first: {
            word: "panda",
            assetName: "pip_course_2d",
          },
          second: {
            word: "pig",
            assetName: "p_word_pig",
          },
          bothTarget: true,
        },
        {
          id: "pear-dog",
          first: {
            word: "pear",
            assetName: "p_word_pear",
          },
          second: {
            word: "dog",
            assetName: "d_word_dog",
          },
          bothTarget: false,
        },
        {
          id: "paper-pencil",
          first: {
            word: "paper",
            assetName: "ch_litter_paper",
          },
          second: {
            word: "pencil",
            assetName: "p_word_pencil",
          },
          bothTarget: true,
        },
        {
          id: "puzzle-fish",
          first: {
            word: "puzzle",
            assetName: "p_word_puzzle",
          },
          second: {
            word: "fish",
            assetName: "f_word_fish",
          },
          bothTarget: false,
        },
        {
          id: "paintbrush-apple",
          first: {
            word: "paintbrush",
            assetName: "p_word_paintbrush",
          },
          second: {
            word: "apple",
            assetName: "a_word_apple",
          },
          bothTarget: false,
        },
      ],
      wordBank: [
        { word: "panda", assetName: "pip_course_2d", isTarget: true, startingSound: "initialP" },
        { word: "paper", assetName: "ch_litter_paper", isTarget: true, startingSound: "initialP" },
        { word: "paintbrush", assetName: "p_word_paintbrush", isTarget: true, startingSound: "initialP" },
        { word: "pear", assetName: "p_word_pear", isTarget: true, startingSound: "initialP" },
        { word: "pencil", assetName: "p_word_pencil", isTarget: true, startingSound: "initialP" },
        { word: "pig", assetName: "p_word_pig", isTarget: true, startingSound: "initialP" },
        { word: "puzzle", assetName: "p_word_puzzle", isTarget: true, startingSound: "initialP" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "P Case Partners",
      prompt: "P Case Partners",
      background: "p_game_case_partners_bg",
      items: [
        { word: "panda", assetName: "pip_course_2d", isTarget: true, startingSound: "initialP" },
        { word: "paper", assetName: "ch_litter_paper", isTarget: true, startingSound: "initialP" },
        { word: "paintbrush", assetName: "p_word_paintbrush", isTarget: true, startingSound: "initialP" },
        { word: "pear", assetName: "p_word_pear", isTarget: true, startingSound: "initialP" },
        { word: "pencil", assetName: "p_word_pencil", isTarget: true, startingSound: "initialP" },
        { word: "pig", assetName: "p_word_pig", isTarget: true, startingSound: "initialP" },
        { word: "puzzle", assetName: "p_word_puzzle", isTarget: true, startingSound: "initialP" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    missingInitial: {
      engine: "wordBuilder",
      title: "Finish the P Word",
      prompt: "Finish the P Word",
      background: "p_game_missing_initial_bg",
      items: [
        { word: "panda", assetName: "pip_course_2d", isTarget: true, startingSound: "initialP" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "pear", assetName: "p_word_pear", isTarget: true, startingSound: "initialP" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "pig", assetName: "p_word_pig", isTarget: true, startingSound: "initialP" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "P Picture Sentences",
      prompt: "P Picture Sentences",
      background: "p_game_sentence_picnic_bg",
      prompts: [
        {
          id: "panda-bear",
          visibleFrame: "The blank is a black-and-white bear.",
          spokenInstruction: "Choose the picture that completes the sentence. The blank is a black-and-white bear.",
          completedSentence: "The panda is a black-and-white bear.",
          answer: "initialPWords",
        },
        {
          id: "write-pencil",
          visibleFrame: "I write with a blank.",
          spokenInstruction: "Choose the picture that completes the sentence. I write with a blank.",
          completedSentence: "I write with a pencil.",
          answer: "initialPWords",
        },
        {
          id: "pieces-puzzle",
          visibleFrame: "I fit the pieces into a blank.",
          spokenInstruction: "Choose the picture that completes the sentence. I fit the pieces into a blank.",
          completedSentence: "I fit the pieces into a puzzle.",
          answer: "initialPWords",
        },
      ],
      wordBank: [
        { word: "panda", assetName: "pip_course_2d", isTarget: true, startingSound: "initialP" },
        { word: "paper", assetName: "ch_litter_paper", isTarget: true, startingSound: "initialP" },
        { word: "paintbrush", assetName: "p_word_paintbrush", isTarget: true, startingSound: "initialP" },
        { word: "pear", assetName: "p_word_pear", isTarget: true, startingSound: "initialP" },
        { word: "pencil", assetName: "p_word_pencil", isTarget: true, startingSound: "initialP" },
        { word: "pig", assetName: "p_word_pig", isTarget: true, startingSound: "initialP" },
        { word: "puzzle", assetName: "p_word_puzzle", isTarget: true, startingSound: "initialP" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    traceP: {
      engine: "guidedTrace",
      title: "Trace P and p",
      prompt: "Trace P and p",
      background: "p_game_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "P",
          prompts: [],
          strokes: [
            [{ x: 0.34, y: 0.17 }, { x: 0.34, y: 0.5 }, { x: 0.34, y: 0.84 }],
            [{ x: 0.34, y: 0.18 }, { x: 0.54, y: 0.15 }, { x: 0.72, y: 0.24 }, { x: 0.76, y: 0.38 }, { x: 0.69, y: 0.5 }, { x: 0.53, y: 0.54 }, { x: 0.34, y: 0.51 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "p",
          prompts: [],
          strokes: [
            [{ x: 0.36, y: 0.35 }, { x: 0.36, y: 0.61 }, { x: 0.36, y: 0.88 }],
            [{ x: 0.36, y: 0.38 }, { x: 0.54, y: 0.32 }, { x: 0.69, y: 0.42 }, { x: 0.72, y: 0.57 }, { x: 0.65, y: 0.7 }, { x: 0.5, y: 0.72 }, { x: 0.36, y: 0.63 }],
          ],
          strokeCount: 2,
        },
      },
    },
  },
  Q: {
    quTeamConnect: {
      engine: "genericTap",
      title: "Meet Letter Q",
      prompt: "Meet Letter Q",
      background: "q_game_qu_team_courtyard_bg",
      items: [
        { word: "queen", assetName: "q_word_queen" },
        { word: "quilt", assetName: "q_word_quilt" },
        { word: "quail", assetName: "q_word_quail" },
        { word: "quill", assetName: "q_word_quill" },
        { word: "quarter", assetName: "q_word_quarter" },
        { word: "moon", assetName: "a_word_moon" },
        { word: "apple", assetName: "a_word_apple" },
        { word: "fish", assetName: "f_word_fish" },
        { word: "kite", assetName: "k_word_kite" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "Q Case Partners",
      prompt: "Q Case Partners",
      background: "q_game_case_partner_studio_bg",
      items: [
        { word: "queen", assetName: "q_word_queen" },
        { word: "quilt", assetName: "q_word_quilt" },
        { word: "quail", assetName: "q_word_quail" },
        { word: "quill", assetName: "q_word_quill" },
        { word: "quarter", assetName: "q_word_quarter" },
        { word: "moon", assetName: "a_word_moon" },
        { word: "apple", assetName: "a_word_apple" },
        { word: "fish", assetName: "f_word_fish" },
        { word: "kite", assetName: "k_word_kite" },
      ],
    },
    soundPairDetective: {
      engine: "soundPairs",
      title: "Q-U Sound Detective",
      prompt: "Q-U Sound Detective",
      background: "q_game_sound_pair_meadow_bg",
      pairs: [
        {
          id: "queen-quilt",
          firstWord: "queen",
          secondWord: "quilt",
          bothTarget: true,
        },
        {
          id: "quail-moon",
          firstWord: "quail",
          secondWord: "moon",
          bothTarget: false,
        },
        {
          id: "quill-quarter",
          firstWord: "quill",
          secondWord: "quarter",
          bothTarget: true,
        },
        {
          id: "apple-queen",
          firstWord: "apple",
          secondWord: "queen",
          bothTarget: false,
        },
        {
          id: "quarter-quail",
          firstWord: "quarter",
          secondWord: "quail",
          bothTarget: true,
        },
      ],
      wordBank: [
        { word: "queen", assetName: "q_word_queen" },
        { word: "quilt", assetName: "q_word_quilt" },
        { word: "quail", assetName: "q_word_quail" },
        { word: "quill", assetName: "q_word_quill" },
        { word: "quarter", assetName: "q_word_quarter" },
        { word: "moon", assetName: "a_word_moon" },
        { word: "apple", assetName: "a_word_apple" },
        { word: "fish", assetName: "f_word_fish" },
        { word: "kite", assetName: "k_word_kite" },
      ],
    },
    quCallSequence: {
      engine: "callSequence",
      title: "Quiet Q-U Call",
      prompt: "Quiet Q-U Call",
      background: "q_game_call_lagoon_bg",
      rounds: [
        {
          id: "queen-quilt",
          sequence: [
            "queen",
            "quilt",
          ],
          choices: [
            "queen",
            "quilt",
            "quail",
            "quill",
          ],
        },
        {
          id: "quail-quill",
          sequence: [
            "quail",
            "quill",
          ],
          choices: [
            "quill",
            "quarter",
            "queen",
            "quail",
          ],
        },
        {
          id: "quarter-quilt-queen",
          sequence: [
            "quarter",
            "quilt",
            "queen",
          ],
          choices: [
            "queen",
            "quarter",
            "quill",
            "quilt",
          ],
        },
      ],
      items: [
        { word: "queen", assetName: "q_word_queen" },
        { word: "quilt", assetName: "q_word_quilt" },
        { word: "quail", assetName: "q_word_quail" },
        { word: "quill", assetName: "q_word_quill" },
        { word: "quarter", assetName: "q_word_quarter" },
        { word: "moon", assetName: "a_word_moon" },
        { word: "apple", assetName: "a_word_apple" },
        { word: "fish", assetName: "f_word_fish" },
        { word: "kite", assetName: "k_word_kite" },
      ],
    },
    addTheTail: {
      engine: "strokeAssembly",
      title: "Give Q Its Tail",
      prompt: "Give Q Its Tail",
      background: "q_game_tail_workshop_bg",
      pieces: [
        {
          id: "uppercase-tail",
          x: 0.6,
          y: 0.55,
        },
        {
          id: "lowercase-tail",
          x: 0.57,
          y: 0.48,
        },
      ],
    },
    missingQBuilder: {
      engine: "wordBuilder",
      title: "Finish the Q-U Word",
      prompt: "Finish the Q-U Word",
      background: "q_game_word_finish_library_bg",
      rounds: [
        {
          word: "queen",
          choices: [
            "q",
            "g",
            "p",
          ],
        },
        {
          word: "apple",
          choices: [
            "q",
            "a",
            "e",
          ],
        },
        {
          word: "quail",
          choices: [
            "g",
            "d",
            "q",
          ],
        },
        {
          word: "fish",
          choices: [
            "q",
            "f",
            "s",
          ],
        },
      ],
    },
    meaningGarden: {
      engine: "sentenceMeaning",
      title: "Q-U Meaning Garden",
      prompt: "Q-U Meaning Garden",
      background: "q_game_meaning_pavilion_bg",
      prompts: [
        {
          id: "queen-crown",
          visibleFrame: "The _____ wears a bright crown.",
          spokenInstruction: "The blank wears a bright crown. Which picture completes the idea?",
          completedSentence: "The queen wears a bright crown.",
          answer: "queen",
        },
        {
          id: "quilt-bed",
          visibleFrame: "The warm _____ is on the bed.",
          spokenInstruction: "The warm blank is on the bed. Which picture completes the idea?",
          completedSentence: "The warm quilt is on the bed.",
          answer: "quilt",
        },
        {
          id: "quail-grass",
          visibleFrame: "The small _____ walks in the grass.",
          spokenInstruction: "The small blank walks in the grass. Which picture completes the idea?",
          completedSentence: "The small quail walks in the grass.",
          answer: "quail",
        },
        {
          id: "quill-write",
          visibleFrame: "Long ago, people wrote with a _____.",
          spokenInstruction: "Long ago, people wrote with a blank. Which picture completes the idea?",
          completedSentence: "Long ago, people wrote with a quill.",
          answer: "quill",
        },
      ],
      wordBank: [
        { word: "queen", assetName: "q_word_queen" },
        { word: "quilt", assetName: "q_word_quilt" },
        { word: "quail", assetName: "q_word_quail" },
        { word: "quill", assetName: "q_word_quill" },
        { word: "quarter", assetName: "q_word_quarter" },
        { word: "moon", assetName: "a_word_moon" },
        { word: "apple", assetName: "a_word_apple" },
        { word: "fish", assetName: "f_word_fish" },
        { word: "kite", assetName: "k_word_kite" },
      ],
    },
  },
  R: {
    soundRoad: {
      engine: "genericTap",
      title: "Ride the R Sound",
      prompt: "Ride the R Sound",
      background: "r_game_sound_road_bg",
      items: [
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "initialR" },
        { word: "rainbow", assetName: "ch_rainbow", isTarget: true, startingSound: "initialR" },
        { word: "rose", assetName: "r_word_rose", isTarget: true, startingSound: "initialR" },
        { word: "robot", assetName: "r_word_robot", isTarget: true, startingSound: "initialR" },
        { word: "rocket", assetName: "r_word_rocket", isTarget: true, startingSound: "initialR" },
        { word: "ruler", assetName: "r_word_ruler", isTarget: true, startingSound: "initialR" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "R Sound-Pair Detective",
      prompt: "R Sound-Pair Detective",
      background: "r_game_sound_pairs_bg",
      pairs: [
        {
          id: "rabbit-rainbow",
          firstWord: "rabbit",
          secondWord: "rainbow",
          bothTarget: true,
        },
        {
          id: "rose-dog",
          firstWord: "rose",
          secondWord: "dog",
          bothTarget: false,
        },
        {
          id: "robot-rocket",
          firstWord: "robot",
          secondWord: "rocket",
          bothTarget: true,
        },
        {
          id: "ruler-moon",
          firstWord: "ruler",
          secondWord: "moon",
          bothTarget: false,
        },
        {
          id: "rainbow-fish",
          firstWord: "rainbow",
          secondWord: "fish",
          bothTarget: false,
        },
      ],
      wordBank: [
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "initialR" },
        { word: "rainbow", assetName: "ch_rainbow", isTarget: true, startingSound: "initialR" },
        { word: "rose", assetName: "r_word_rose", isTarget: true, startingSound: "initialR" },
        { word: "robot", assetName: "r_word_robot", isTarget: true, startingSound: "initialR" },
        { word: "rocket", assetName: "r_word_rocket", isTarget: true, startingSound: "initialR" },
        { word: "ruler", assetName: "r_word_ruler", isTarget: true, startingSound: "initialR" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "R Case Partners",
      prompt: "R Case Partners",
      background: "r_game_case_partners_bg",
      items: [
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "initialR" },
        { word: "rainbow", assetName: "ch_rainbow", isTarget: true, startingSound: "initialR" },
        { word: "rose", assetName: "r_word_rose", isTarget: true, startingSound: "initialR" },
        { word: "robot", assetName: "r_word_robot", isTarget: true, startingSound: "initialR" },
        { word: "rocket", assetName: "r_word_rocket", isTarget: true, startingSound: "initialR" },
        { word: "ruler", assetName: "r_word_ruler", isTarget: true, startingSound: "initialR" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    wordRepair: {
      engine: "wordBuilder",
      title: "Repair the R Word",
      prompt: "Repair the R Word",
      background: "r_game_word_repair_bg",
      rounds: [
        {
          word: "rainbow",
          choices: [
            "R",
            "B",
            "M",
          ],
        },
        {
          word: "apple",
          choices: [
            "R",
            "A",
            "E",
          ],
        },
        {
          word: "robot",
          choices: [
            "T",
            "P",
            "R",
          ],
        },
        {
          word: "fish",
          choices: [
            "R",
            "F",
            "S",
          ],
        },
        {
          word: "ruler",
          choices: [
            "L",
            "R",
            "N",
          ],
        },
      ],
    },
    soundRoute: {
      engine: "callSequence",
      title: "Remember the R Route",
      prompt: "Remember the R Route",
      background: "r_game_sound_route_bg",
      rounds: [
        {
          id: "two-rabbit-rose",
          sequence: [
            "rabbit",
            "rose",
          ],
          choices: [
            "rabbit",
            "rose",
            "robot",
            "rainbow",
          ],
        },
        {
          id: "two-rocket-ruler",
          sequence: [
            "rocket",
            "ruler",
          ],
          choices: [
            "rocket",
            "ruler",
            "rose",
            "robot",
          ],
        },
        {
          id: "three-robot-rainbow-rabbit",
          sequence: [
            "robot",
            "rainbow",
            "rabbit",
          ],
          choices: [
            "robot",
            "rainbow",
            "rabbit",
            "rocket",
          ],
        },
      ],
      items: [
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "initialR" },
        { word: "rainbow", assetName: "ch_rainbow", isTarget: true, startingSound: "initialR" },
        { word: "rose", assetName: "r_word_rose", isTarget: true, startingSound: "initialR" },
        { word: "robot", assetName: "r_word_robot", isTarget: true, startingSound: "initialR" },
        { word: "rocket", assetName: "r_word_rocket", isTarget: true, startingSound: "initialR" },
        { word: "ruler", assetName: "r_word_ruler", isTarget: true, startingSound: "initialR" },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "R Sentence Meaning",
      prompt: "R Sentence Meaning",
      background: "r_game_sentence_meaning_bg",
      prompts: [
        {
          id: "furry-animal",
          visibleFrame: "The blank is a furry animal.",
          spokenInstruction: "Choose the picture that completes the idea. The blank is a furry animal.",
          completedSentence: "The rabbit is a furry animal.",
          answer: "rabbit",
        },
        {
          id: "colorful-sky",
          visibleFrame: "The blank is colorful in the sky.",
          spokenInstruction: "Choose the picture that completes the idea. The blank is colorful in the sky.",
          completedSentence: "The rainbow is colorful in the sky.",
          answer: "rainbow",
        },
        {
          id: "has-petals",
          visibleFrame: "The blank has petals.",
          spokenInstruction: "Choose the picture that completes the idea. The blank has petals.",
          completedSentence: "The rose has petals.",
          answer: "rose",
        },
        {
          id: "measures-length",
          visibleFrame: "The blank helps measure length.",
          spokenInstruction: "Choose the picture that completes the idea. The blank helps measure length.",
          completedSentence: "The ruler helps measure length.",
          answer: "ruler",
        },
      ],
      wordBank: [
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "initialR" },
        { word: "rainbow", assetName: "ch_rainbow", isTarget: true, startingSound: "initialR" },
        { word: "rose", assetName: "r_word_rose", isTarget: true, startingSound: "initialR" },
        { word: "robot", assetName: "r_word_robot", isTarget: true, startingSound: "initialR" },
        { word: "rocket", assetName: "r_word_rocket", isTarget: true, startingSound: "initialR" },
        { word: "ruler", assetName: "r_word_ruler", isTarget: true, startingSound: "initialR" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "other" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
      ],
    },
    buildR: {
      engine: "strokeAssembly",
      title: "Build R and r",
      prompt: "Build R and r",
      background: "r_game_build_letter_bg",
      pieces: [
        {
          id: "stem",
          x: 0.4,
          y: 0.38,
        },
        {
          id: "bowl",
          x: 0.56,
          y: 0.27,
        },
        {
          id: "leg",
          x: 0.58,
          y: 0.5,
        },
        {
          id: "stem",
          x: 0.45,
          y: 0.38,
        },
        {
          id: "shoulder",
          x: 0.59,
          y: 0.25,
        },
      ],
    },
  },
  S: {
    soundSlider: {
      engine: "genericTap",
      title: "Slide into S",
      prompt: "Slide into S",
      background: "f_game_friendly_forest_discovery_bg",
      items: [
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "initialS" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: true, startingSound: "initialS" },
        { word: "spoon", assetName: "bakery_spoon", isTarget: true, startingSound: "initialS" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "finalS" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "finalS" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "finalS" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "S Sound Pairs",
      prompt: "S Sound Pairs",
      background: "g_game_gazebo_picture_match_bg",
      pairs: [
        {
          id: "sun-sock",
          bothTarget: true,
          first: {
            word: "sun",
            assetName: "call_sun",
          },
          second: {
            word: "sock",
            assetName: "f_distractor_sock",
          },
        },
        {
          id: "spoon-rabbit",
          bothTarget: false,
          first: {
            word: "spoon",
            assetName: "bakery_spoon",
          },
          second: {
            word: "rabbit",
            assetName: "f_distractor_rabbit",
          },
        },
        {
          id: "sock-spoon",
          bothTarget: true,
          first: {
            word: "sock",
            assetName: "f_distractor_sock",
          },
          second: {
            word: "spoon",
            assetName: "bakery_spoon",
          },
        },
        {
          id: "apple-moon",
          bothTarget: false,
          first: {
            word: "apple",
            assetName: "a_word_apple",
          },
          second: {
            word: "moon",
            assetName: "a_word_moon",
          },
        },
      ],
      wordBank: [
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "initialS" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: true, startingSound: "initialS" },
        { word: "spoon", assetName: "bakery_spoon", isTarget: true, startingSound: "initialS" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "finalS" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "finalS" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "finalS" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "S Case Partners",
      prompt: "S Case Partners",
      background: "i_game_ink_lantern_hunt_bg",
      items: [
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "initialS" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: true, startingSound: "initialS" },
        { word: "spoon", assetName: "bakery_spoon", isTarget: true, startingSound: "initialS" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "finalS" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "finalS" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "finalS" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    soundSpots: {
      engine: "soundPosition",
      title: "Where Is the S Sound?",
      prompt: "Where Is the S Sound?",
      background: "i_game_ice_bridge_contrast_bg",
      items: [
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "initialS" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: true, startingSound: "initialS" },
        { word: "spoon", assetName: "bakery_spoon", isTarget: true, startingSound: "initialS" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "finalS" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "finalS" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "finalS" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    wordBuilder: {
      engine: "wordBuilder",
      title: "Finish the S Word",
      prompt: "Finish the S Word",
      background: "e_game_word_workshop_bg",
      rounds: [
        {
          word: "sun",
          choices: [
            "s",
            "m",
            "t",
          ],
        },
        {
          word: "sock",
          choices: [
            "b",
            "s",
            "f",
          ],
        },
        {
          word: "spoon",
          choices: [
            "s",
            "p",
            "t",
          ],
        },
      ],
    },
    sentenceSense: {
      engine: "sentenceMeaning",
      title: "S Sentence Sense",
      prompt: "S Sentence Sense",
      background: "f_game_forest_story_sentence_bg",
      prompts: [
        {
          id: "sun-shines",
          visibleFrame: "The _____ shines.",
          spokenInstruction: "Complete this sentence. The blank shines.",
          completedSentence: "The sun shines.",
          answer: "sun",
        },
        {
          id: "wear-sock",
          visibleFrame: "I wear a _____.",
          spokenInstruction: "Complete this sentence. I wear a blank.",
          completedSentence: "I wear a sock.",
          answer: "sock",
        },
        {
          id: "stir-spoon",
          visibleFrame: "Stir with a _____.",
          spokenInstruction: "Complete this sentence. Stir with a blank.",
          completedSentence: "Stir with a spoon.",
          answer: "spoon",
        },
      ],
      wordBank: [
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "initialS" },
        { word: "sock", assetName: "f_distractor_sock", isTarget: true, startingSound: "initialS" },
        { word: "spoon", assetName: "bakery_spoon", isTarget: true, startingSound: "initialS" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "finalS" },
        { word: "mouse", assetName: "m_word_mouse", isTarget: true, startingSound: "finalS" },
        { word: "house", assetName: "h_word_house", isTarget: true, startingSound: "finalS" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: false, startingSound: "other" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
      ],
    },
    traceS: {
      engine: "guidedTrace",
      title: "Trace S and s",
      prompt: "Trace S and s",
      background: "i_game_illustration_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "S",
          prompts: [],
          strokes: [
            [{ x: 0.7, y: 0.23 }, { x: 0.62, y: 0.16 }, { x: 0.49, y: 0.14 }, { x: 0.37, y: 0.19 }, { x: 0.3, y: 0.29 }, { x: 0.33, y: 0.39 }, { x: 0.44, y: 0.46 }, { x: 0.57, y: 0.5 }, { x: 0.67, y: 0.57 }, { x: 0.71, y: 0.68 }, { x: 0.66, y: 0.79 }, { x: 0.55, y: 0.86 }, { x: 0.42, y: 0.86 }, { x: 0.31, y: 0.79 }],
            [{ x: 0.65, y: 0.31 }, { x: 0.57, y: 0.25 }, { x: 0.46, y: 0.24 }, { x: 0.37, y: 0.29 }, { x: 0.34, y: 0.38 }, { x: 0.41, y: 0.45 }, { x: 0.52, y: 0.49 }, { x: 0.62, y: 0.54 }, { x: 0.66, y: 0.63 }, { x: 0.61, y: 0.72 }, { x: 0.51, y: 0.77 }, { x: 0.4, y: 0.74 }, { x: 0.34, y: 0.68 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "s",
          prompts: [],
          strokes: [
            [{ x: 0.65, y: 0.31 }, { x: 0.57, y: 0.25 }, { x: 0.46, y: 0.24 }, { x: 0.37, y: 0.29 }, { x: 0.34, y: 0.38 }, { x: 0.41, y: 0.45 }, { x: 0.52, y: 0.49 }, { x: 0.62, y: 0.54 }, { x: 0.66, y: 0.63 }, { x: 0.61, y: 0.72 }, { x: 0.51, y: 0.77 }, { x: 0.4, y: 0.74 }, { x: 0.34, y: 0.68 }],
          ],
          strokeCount: 1,
        },
      }
    },
  },
  T: {
    soundTrain: {
      engine: "genericTap",
      title: "T Sound Train",
      prompt: "T Sound Train",
      background: "t_game_sound_train_bg",
      items: [
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "beginning" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: true, startingSound: "beginning" },
        { word: "truck", assetName: "a_word_truck", isTarget: true, startingSound: "beginning" },
        { word: "train", assetName: "t_word_train", isTarget: true, startingSound: "beginning" },
        { word: "tiger", assetName: "t_word_tiger", isTarget: true, startingSound: "beginning" },
        { word: "tent", assetName: "t_word_tent", isTarget: true, startingSound: "beginning" },
        { word: "tulip", assetName: "t_word_tulip", isTarget: true, startingSound: "beginning" },
        { word: "cat", assetName: "c_word_cat", isTarget: true, startingSound: "ending" },
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "ending" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "ending" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "absent" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "absent" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "absent" },
      ],
    },
    soundPosition: {
      engine: "soundPosition",
      title: "Where Is the T Sound?",
      prompt: "Where Is the T Sound?",
      background: "t_game_sound_position_bg",
      items: [
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "beginning" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: true, startingSound: "beginning" },
        { word: "truck", assetName: "a_word_truck", isTarget: true, startingSound: "beginning" },
        { word: "train", assetName: "t_word_train", isTarget: true, startingSound: "beginning" },
        { word: "tiger", assetName: "t_word_tiger", isTarget: true, startingSound: "beginning" },
        { word: "tent", assetName: "t_word_tent", isTarget: true, startingSound: "beginning" },
        { word: "tulip", assetName: "t_word_tulip", isTarget: true, startingSound: "beginning" },
        { word: "cat", assetName: "c_word_cat", isTarget: true, startingSound: "ending" },
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "ending" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "ending" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "absent" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "absent" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "absent" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "T Case Partners",
      prompt: "T Case Partners",
      background: "t_game_case_partner_bg",
      items: [
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "beginning" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: true, startingSound: "beginning" },
        { word: "truck", assetName: "a_word_truck", isTarget: true, startingSound: "beginning" },
        { word: "train", assetName: "t_word_train", isTarget: true, startingSound: "beginning" },
        { word: "tiger", assetName: "t_word_tiger", isTarget: true, startingSound: "beginning" },
        { word: "tent", assetName: "t_word_tent", isTarget: true, startingSound: "beginning" },
        { word: "tulip", assetName: "t_word_tulip", isTarget: true, startingSound: "beginning" },
        { word: "cat", assetName: "c_word_cat", isTarget: true, startingSound: "ending" },
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "ending" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "ending" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "absent" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "absent" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "absent" },
      ],
    },
    tapTrail: {
      engine: "callSequence",
      title: "T Tap Trail",
      prompt: "T Tap Trail",
      background: "t_game_tap_trail_bg",
      rounds: [
        {
          id: "tree-train",
          sequence: [
            "tree",
            "train",
          ],
          choices: [
            "tree",
            "train",
            "turtle",
            "truck",
          ],
        },
        {
          id: "tiger-tulip",
          sequence: [
            "tiger",
            "tulip",
          ],
          choices: [
            "tiger",
            "tulip",
            "tent",
            "truck",
          ],
        },
        {
          id: "turtle-tent-train",
          sequence: [
            "turtle",
            "tent",
            "train",
          ],
          choices: [
            "turtle",
            "tent",
            "train",
            "tree",
          ],
        },
      ],
      items: [
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "beginning" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: true, startingSound: "beginning" },
        { word: "truck", assetName: "a_word_truck", isTarget: true, startingSound: "beginning" },
        { word: "train", assetName: "t_word_train", isTarget: true, startingSound: "beginning" },
        { word: "tiger", assetName: "t_word_tiger", isTarget: true, startingSound: "beginning" },
        { word: "tent", assetName: "t_word_tent", isTarget: true, startingSound: "beginning" },
        { word: "tulip", assetName: "t_word_tulip", isTarget: true, startingSound: "beginning" },
        { word: "cat", assetName: "c_word_cat", isTarget: true, startingSound: "ending" },
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "ending" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "ending" },
      ],
    },
    wordBuilder: {
      engine: "wordBuilder",
      title: "T or Not? Word Builder",
      prompt: "T or Not? Word Builder",
      background: "t_game_word_builder_bg",
      rounds: [
        {
          word: "train",
          choices: [
            "T",
            "F",
            "M",
          ],
          answer: "T",
        },
        {
          word: "fish",
          choices: [
            "T",
            "F",
            "P",
          ],
          answer: "F",
        },
        {
          word: "moon",
          choices: [
            "M",
            "T",
            "S",
          ],
          answer: "M",
        },
        {
          word: "tent",
          choices: [
            "P",
            "S",
            "T",
          ],
          answer: "T",
        },
        {
          word: "apple",
          choices: [
            "T",
            "A",
            "M",
          ],
          answer: "A",
        },
        {
          word: "turtle",
          choices: [
            "F",
            "T",
            "A",
          ],
          answer: "T",
        },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "T Sentence Detective",
      prompt: "T Sentence Detective",
      background: "t_game_sentence_meaning_bg",
      prompts: [
        {
          id: "moves-on-tracks",
          visibleFrame: "The _____ moves on tracks.",
          spokenInstruction: "Which picture completes the sentence? The blank moves on tracks.",
          completedSentence: "The train moves on tracks.",
          answer: "train",
        },
        {
          id: "garden-flower",
          visibleFrame: "The _____ is a garden flower.",
          spokenInstruction: "Which picture completes the sentence? The blank is a garden flower.",
          completedSentence: "The tulip is a garden flower.",
          answer: "tulip",
        },
        {
          id: "orange-stripes",
          visibleFrame: "The _____ has orange stripes.",
          spokenInstruction: "Which picture completes the sentence? The blank has orange stripes.",
          completedSentence: "The tiger has orange stripes.",
          answer: "tiger",
        },
        {
          id: "cozy-play-place",
          visibleFrame: "The _____ is a cozy place to play.",
          spokenInstruction: "Which picture completes the sentence? The blank is a cozy place to play.",
          completedSentence: "The tent is a cozy place to play.",
          answer: "tent",
        },
      ],
      wordBank: [
        { word: "tree", assetName: "a_word_tree", isTarget: true, startingSound: "beginning" },
        { word: "turtle", assetName: "f_distractor_turtle", isTarget: true, startingSound: "beginning" },
        { word: "truck", assetName: "a_word_truck", isTarget: true, startingSound: "beginning" },
        { word: "train", assetName: "t_word_train", isTarget: true, startingSound: "beginning" },
        { word: "tiger", assetName: "t_word_tiger", isTarget: true, startingSound: "beginning" },
        { word: "tent", assetName: "t_word_tent", isTarget: true, startingSound: "beginning" },
        { word: "tulip", assetName: "t_word_tulip", isTarget: true, startingSound: "beginning" },
        { word: "cat", assetName: "c_word_cat", isTarget: true, startingSound: "ending" },
        { word: "hat", assetName: "h_word_hat", isTarget: true, startingSound: "ending" },
        { word: "rabbit", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "ending" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "absent" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false, startingSound: "absent" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "absent" },
      ],
    },
    buildT: {
      engine: "strokeAssembly",
      title: "Build T and t",
      prompt: "Build T and t",
      background: "t_game_build_letter_bg",
      pieces: [
        {
          id: "top",
          x: 0.5,
          y: 0.25,
        },
        {
          id: "stem",
          x: 0.5,
          y: 0.48,
        },
        {
          id: "stem",
          x: 0.5,
          y: 0.46,
        },
        {
          id: "crossbar",
          x: 0.5,
          y: 0.36,
        },
      ],
    },
  },
  U: {
    umbrellaDiscovery: {
      engine: "discovery",
      title: "Umbrella U Discovery",
      prompt: "Umbrella U Discovery",
      background: "u_game_umbrella_discovery_bg",
      items: [
        { word: "umbrella", assetName: "ch_umbrella", isTarget: true, startingSound: "startsWithShortU" },
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "shortUInside" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "shortUInside" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "shortUInside" },
        { word: "duck", assetName: "d_word_duck", isTarget: true, startingSound: "shortUInside" },
        { word: "drum", assetName: "d_word_drum", isTarget: true, startingSound: "shortUInside" },
      ],
    },
    shortUSoundPositions: {
      engine: "soundPosition",
      title: "Where Is Short U?",
      prompt: "Where Is Short U?",
      background: "u_game_short_u_sound_garden_bg",
      items: [
        { word: "umbrella", assetName: "ch_umbrella", isTarget: true, startingSound: "startsWithShortU" },
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "shortUInside" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "shortUInside" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "shortUInside" },
        { word: "duck", assetName: "d_word_duck", isTarget: true, startingSound: "shortUInside" },
        { word: "drum", assetName: "d_word_drum", isTarget: true, startingSound: "shortUInside" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherSound" },
        { word: "cake", assetName: "c_word_cake", isTarget: true, startingSound: "otherSound" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "otherSound" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "U Case Partners",
      prompt: "U Case Partners",
      background: "u_game_case_clouds_bg",
      items: [
        { word: "umbrella", assetName: "ch_umbrella", isTarget: true, startingSound: "startsWithShortU" },
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "shortUInside" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "shortUInside" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "shortUInside" },
        { word: "duck", assetName: "d_word_duck", isTarget: true, startingSound: "shortUInside" },
        { word: "drum", assetName: "d_word_drum", isTarget: true, startingSound: "shortUInside" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherSound" },
        { word: "cake", assetName: "c_word_cake", isTarget: true, startingSound: "otherSound" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "otherSound" },
      ],
    },
    underTheArch: {
      engine: "soundPosition",
      title: "Find U in the Word",
      prompt: "Find U in the Word",
      background: "u_game_under_arch_bg",
      items: [
        { word: "umbrella", assetName: "ch_umbrella", isTarget: true, startingSound: "startsWithShortU" },
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "shortUInside" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "shortUInside" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "shortUInside" },
        { word: "duck", assetName: "d_word_duck", isTarget: true, startingSound: "shortUInside" },
        { word: "drum", assetName: "d_word_drum", isTarget: true, startingSound: "shortUInside" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherSound" },
        { word: "cake", assetName: "c_word_cake", isTarget: true, startingSound: "otherSound" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "otherSound" },
      ],
    },
    missingUBuilder: {
      engine: "wordBuilder",
      title: "Put U in the Middle",
      prompt: "Put U in the Middle",
      background: "u_game_word_workshop_bg",
      rounds: [
        {
          id: "sun",
          word: "sun",
          prefix: "s",
          suffix: "n",
          choices: [
            "u",
            "a",
            "i",
          ],
        },
        {
          id: "bus",
          word: "bus",
          prefix: "b",
          suffix: "s",
          choices: [
            "e",
            "u",
            "o",
          ],
        },
        {
          id: "mug",
          word: "mug",
          prefix: "m",
          suffix: "g",
          choices: [
            "i",
            "a",
            "u",
          ],
        },
        {
          id: "duck",
          word: "duck",
          prefix: "d",
          suffix: "ck",
          choices: [
            "u",
            "e",
            "a",
          ],
        },
        {
          id: "drum",
          word: "drum",
          prefix: "dr",
          suffix: "m",
          choices: [
            "o",
            "u",
            "i",
          ],
        },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "U Sentence Pictures",
      prompt: "U Sentence Pictures",
      background: "u_game_sentence_picnic_bg",
      prompts: [
        {
          id: "duck-under-umbrella",
          visibleFrame: "The duck is under the ____.",
          spokenInstruction: "The duck is under the blank. Choose the umbrella.",
          completedSentence: "The duck is under the umbrella.",
          answer: "umbrella",
        },
        {
          id: "ride-bus",
          visibleFrame: "We ride the ____.",
          spokenInstruction: "We ride the blank. Choose the bus.",
          completedSentence: "We ride the bus.",
          answer: "bus",
        },
        {
          id: "warm-sun",
          visibleFrame: "Warm light comes from the ____.",
          spokenInstruction: "Warm light comes from the blank. Choose the sun.",
          completedSentence: "Warm light comes from the sun.",
          answer: "sun",
        },
        {
          id: "cool-drink-mug",
          visibleFrame: "A cool drink goes in the ____.",
          spokenInstruction: "A cool drink goes in the blank. Choose the mug.",
          completedSentence: "A cool drink goes in the mug.",
          answer: "mug",
        },
        {
          id: "duck-swims",
          visibleFrame: "The ____ can swim.",
          spokenInstruction: "The blank can swim. Choose the duck.",
          completedSentence: "The duck can swim.",
          answer: "duck",
        },
      ],
      wordBank: [
        { word: "umbrella", assetName: "ch_umbrella", isTarget: true, startingSound: "startsWithShortU" },
        { word: "sun", assetName: "call_sun", isTarget: true, startingSound: "shortUInside" },
        { word: "bus", assetName: "a_word_bus", isTarget: true, startingSound: "shortUInside" },
        { word: "mug", assetName: "m_word_mug", isTarget: true, startingSound: "shortUInside" },
        { word: "duck", assetName: "d_word_duck", isTarget: true, startingSound: "shortUInside" },
        { word: "drum", assetName: "d_word_drum", isTarget: true, startingSound: "shortUInside" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "otherSound" },
        { word: "cake", assetName: "c_word_cake", isTarget: true, startingSound: "otherSound" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "otherSound" },
      ],
    },
    traceU: {
      engine: "guidedTrace",
      title: "Trace U and u",
      prompt: "Trace U and u",
      background: "u_game_trace_rainbow_studio_bg",
      cases: {
        uppercase: {
          glyph: "U",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.27, y: 0.18 }, { x: 0.27, y: 0.64 }, { x: 0.73, y: 0.64 }, { x: 0.73, y: 0.18 }, { x: 0.27, y: 0.86 }, { x: 0.73, y: 0.86 }],
          ],
          strokeCount: 1,
        },
        lowercase: {
          glyph: "u",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.31, y: 0.35 }, { x: 0.31, y: 0.67 }, { x: 0.66, y: 0.67 }, { x: 0.66, y: 0.35 }, { x: 0.31, y: 0.82 }, { x: 0.66, y: 0.82 }, { x: 0.66, y: 0.76 }, { x: 0.66, y: 0.76 }, { x: 0.76, y: 0.76 }],
          ],
          strokeCount: 1,
        },
      },
      notes: "Keyframe CGPoints from size.width/height factors (procedural path approximated).",
    },
  },
  V: {
    soundSlide: {
      engine: "genericTap",
      title: "V Sound Voyage",
      prompt: "V Sound Voyage",
      background: "v_game_voice_valley_bg",
      items: [
        { word: "van", assetName: "post_van", isTarget: true },
        { word: "vase", assetName: "v_word_vase", isTarget: true },
        { word: "vest", assetName: "v_word_vest", isTarget: true },
        { word: "violin", assetName: "v_word_violin", isTarget: true },
        { word: "vegetables", assetName: "v_word_vegetables", isTarget: true },
        { word: "vacuum", assetName: "v_word_vacuum", isTarget: true },
        { word: "apple", assetName: "a_word_apple", isTarget: false },
        { word: "dog", assetName: "d_word_dog", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "V Case Partners",
      prompt: "V Case Partners",
      background: "v_game_case_violet_kite_bg",
      items: [
        { word: "van", assetName: "post_van", isTarget: true },
        { word: "vase", assetName: "v_word_vase", isTarget: true },
        { word: "vest", assetName: "v_word_vest", isTarget: true },
        { word: "violin", assetName: "v_word_violin", isTarget: true },
        { word: "vegetables", assetName: "v_word_vegetables", isTarget: true },
        { word: "vacuum", assetName: "v_word_vacuum", isTarget: true },
        { word: "apple", assetName: "a_word_apple", isTarget: false },
        { word: "dog", assetName: "d_word_dog", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
      ],
    },
    soundPairDetective: {
      engine: "soundPairs",
      title: "V Sound Detective",
      prompt: "V Sound Detective",
      background: "v_game_sound_village_bg",
      pairs: [
        {
          id: "van-vase",
          firstWord: "van",
          secondWord: "vase",
          bothTarget: true,
        },
        {
          id: "vest-apple",
          firstWord: "vest",
          secondWord: "apple",
          bothTarget: false,
        },
        {
          id: "violin-vegetables",
          firstWord: "violin",
          secondWord: "vegetables",
          bothTarget: true,
        },
        {
          id: "vacuum-dog",
          firstWord: "vacuum",
          secondWord: "dog",
          bothTarget: false,
        },
        {
          id: "vase-vest",
          firstWord: "vase",
          secondWord: "vest",
          bothTarget: true,
        },
      ],
      wordBank: [
        { word: "van", assetName: "post_van", isTarget: true },
        { word: "vase", assetName: "v_word_vase", isTarget: true },
        { word: "vest", assetName: "v_word_vest", isTarget: true },
        { word: "violin", assetName: "v_word_violin", isTarget: true },
        { word: "vegetables", assetName: "v_word_vegetables", isTarget: true },
        { word: "vacuum", assetName: "v_word_vacuum", isTarget: true },
        { word: "apple", assetName: "a_word_apple", isTarget: false },
        { word: "dog", assetName: "d_word_dog", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
      ],
    },
    wordCallSequence: {
      engine: "callSequence",
      title: "V Word Call",
      prompt: "V Word Call",
      background: "v_game_word_call_veranda_bg",
      rounds: [
        {
          id: "van-vase",
          sequence: [
            "van",
            "vase",
          ],
          choices: [
            "van",
            "vest",
            "vase",
            "violin",
          ],
        },
        {
          id: "vest-violin",
          sequence: [
            "vest",
            "violin",
          ],
          choices: [
            "vegetables",
            "violin",
            "vacuum",
            "vest",
          ],
        },
        {
          id: "vacuum-vegetables-van",
          sequence: [
            "vacuum",
            "vegetables",
            "van",
          ],
          choices: [
            "van",
            "vase",
            "vegetables",
            "vacuum",
          ],
        },
      ],
      items: [
        { word: "van", assetName: "post_van", isTarget: true },
        { word: "vase", assetName: "v_word_vase", isTarget: true },
        { word: "vest", assetName: "v_word_vest", isTarget: true },
        { word: "violin", assetName: "v_word_violin", isTarget: true },
        { word: "vegetables", assetName: "v_word_vegetables", isTarget: true },
        { word: "vacuum", assetName: "v_word_vacuum", isTarget: true },
      ],
    },
    buildV: {
      engine: "strokeAssembly",
      title: "Build the V",
      prompt: "Build the V",
      background: "v_game_build_viewpoint_bg",
      pieces: [
        {
          id: "left",
          x: 0.4,
          y: 0.38,
        },
        {
          id: "right",
          x: 0.6,
          y: 0.38,
        },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "V Meaning Garden",
      prompt: "V Meaning Garden",
      background: "v_game_meaning_vegetable_garden_bg",
      prompts: [
        {
          id: "flowers-vase",
          visibleFrame: "The flowers are in the _____.",
          spokenInstruction: "The flowers are in the blank. Which picture completes the idea?",
          completedSentence: "The flowers are in the vase.",
          answer: "vase",
          choices: [
            "vest",
            "vase",
            "vacuum",
          ],
        },
        {
          id: "wear-vest",
          visibleFrame: "I wear the _____.",
          spokenInstruction: "I wear the blank. Which picture completes the idea?",
          completedSentence: "I wear the vest.",
          answer: "vest",
          choices: [
            "violin",
            "vest",
            "vegetables",
          ],
        },
        {
          id: "hear-violin",
          visibleFrame: "We hear the _____.",
          spokenInstruction: "We hear the blank. Which picture completes the idea?",
          completedSentence: "We hear the violin.",
          answer: "violin",
          choices: [
            "van",
            "vacuum",
            "violin",
          ],
        },
        {
          id: "vacuum-rug",
          visibleFrame: "The _____ cleans the rug.",
          spokenInstruction: "The blank cleans the rug. Which picture completes the idea?",
          completedSentence: "The vacuum cleans the rug.",
          answer: "vacuum",
          choices: [
            "vase",
            "vacuum",
            "vest",
          ],
        },
      ],
      wordBank: [
        { word: "van", assetName: "post_van", isTarget: true },
        { word: "vase", assetName: "v_word_vase", isTarget: true },
        { word: "vest", assetName: "v_word_vest", isTarget: true },
        { word: "violin", assetName: "v_word_violin", isTarget: true },
        { word: "vegetables", assetName: "v_word_vegetables", isTarget: true },
        { word: "vacuum", assetName: "v_word_vacuum", isTarget: true },
        { word: "apple", assetName: "a_word_apple", isTarget: false },
        { word: "dog", assetName: "d_word_dog", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
      ],
    },
    traceV: {
      engine: "guidedTrace",
      title: "Trace V and v",
      prompt: "Trace V and v",
      background: "v_game_trace_violet_studio_bg",
      cases: {
        uppercase: {
          glyph: "V",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.22, y: 0.18 }, { x: 0.5, y: 0.82 }],
            [{ x: 0.5, y: 0.82 }, { x: 0.78, y: 0.18 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "v",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.3, y: 0.34 }, { x: 0.5, y: 0.82 }],
            [{ x: 0.5, y: 0.82 }, { x: 0.7, y: 0.34 }],
          ],
          strokeCount: 2,
        },
      },
      notes: "Endpoints from size.width/height factor lets in Swift.",
    },
  },
  W: {
    soundSlide: {
      engine: "genericTap",
      title: "Wind Sound Slide",
      prompt: "Wind Sound Slide",
      background: "w_game_windy_sound_slide_bg",
      items: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "W Case Partners",
      prompt: "W Case Partners",
      background: "w_game_window_case_pavilion_bg",
      items: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
      ],
    },
    pictureMemory: {
      engine: "memoryPair",
      title: "W Window Memory",
      prompt: "W Window Memory",
      background: "w_game_woodland_memory_nook_bg",
      items: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
      ],
    },
    soundPairs: {
      engine: "soundPairs",
      title: "W Sound Pairs",
      prompt: "W Sound Pairs",
      background: "w_game_willow_sound_pairs_bg",
      pairs: [
        {
          id: "wagon-water",
          firstWord: "wagon",
          secondWord: "water",
          bothTarget: true,
        },
        {
          id: "walrus-dog",
          firstWord: "walrus",
          secondWord: "dog",
          bothTarget: false,
        },
        {
          id: "watch-window",
          firstWord: "watch",
          secondWord: "window",
          bothTarget: true,
        },
        {
          id: "web-apple",
          firstWord: "web",
          secondWord: "apple",
          bothTarget: false,
        },
        {
          id: "water-fish",
          firstWord: "water",
          secondWord: "fish",
          bothTarget: false,
        },
      ],
      wordBank: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
      ],
    },
    buildW: {
      engine: "strokeAssembly",
      title: "Build Four-Stroke W",
      prompt: "Build Four-Stroke W",
      background: "w_game_four_stroke_workshop_bg",
      notes: "Piece/target layout not fully extractable from Swift (may be code-drawn).",
    },
    missingWBuilder: {
      engine: "wordBuilder",
      title: "Finish the W Word",
      prompt: "Finish the W Word",
      background: "w_game_winding_word_workshop_bg",
      targetLetter: "W",
      items: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "W Wonder Sentences",
      prompt: "W Wonder Sentences",
      background: "w_game_wonder_sentence_gazebo_bg",
      prompts: [
        {
          id: "four-wheels",
          visibleFrame: "The red ________ rolls on four wheels.",
          spokenInstruction: null,
          completedSentence: "The red wagon rolls on four wheels.",
          answer: "wagon",
          choices: [
            "wagon",
            "watch",
            "window",
          ],
        },
        {
          id: "two-tusks",
          visibleFrame: "The ________ has two smooth tusks.",
          spokenInstruction: null,
          completedSentence: "The walrus has two smooth tusks.",
          answer: "walrus",
          choices: [
            "walrus",
            "web",
            "wagon",
          ],
        },
        {
          id: "check-time",
          visibleFrame: "I wear a ________ to check the time.",
          spokenInstruction: null,
          completedSentence: "I wear a watch to check the time.",
          answer: "watch",
          choices: [
            "water",
            "watch",
            "window",
          ],
        },
        {
          id: "see-outside",
          visibleFrame: "I look through the ________ to see outside.",
          spokenInstruction: null,
          completedSentence: "I look through the window to see outside.",
          answer: "window",
          choices: [
            "web",
            "wagon",
            "window",
          ],
        },
        {
          id: "plants-need",
          visibleFrame: "Plants need ________ to grow.",
          spokenInstruction: null,
          completedSentence: "Plants need water to grow.",
          answer: "water",
          choices: [
            "watch",
            "water",
            "walrus",
          ],
        },
      ],
      wordBank: [
        { word: "wagon", assetName: "w_word_wagon", isTarget: true, startingSound: "initialW" },
        { word: "walrus", assetName: "w_word_walrus", isTarget: true, startingSound: "initialW" },
        { word: "watch", assetName: "w_word_watch", isTarget: true, startingSound: "initialW" },
        { word: "web", assetName: "w_word_web", isTarget: true, startingSound: "initialW" },
        { word: "window", assetName: "w_word_window", isTarget: true, startingSound: "initialW" },
        { word: "water", assetName: "ch_waterdrop", isTarget: true, startingSound: "initialW" },
        { word: "apple", assetName: "a_word_apple", isTarget: false, startingSound: "other" },
        { word: "dog", assetName: "d_word_dog", isTarget: false, startingSound: "other" },
        { word: "fish", assetName: "f_word_fish", isTarget: false, startingSound: "other" },
        { word: "moon", assetName: "a_word_moon", isTarget: false, startingSound: "other" },
      ],
    },
  },
  X: {
    soundSpotlight: {
      engine: "genericTap",
      title: "X Sound Spotlight",
      prompt: "X Sound Spotlight",
      background: "x_game_sound_spotlight_bg",
      items: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noXKS" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "X Case Partners",
      prompt: "X Case Partners",
      background: "x_game_case_partner_bg",
      items: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noXKS" },
      ],
    },
    soundPosition: {
      engine: "soundPosition",
      title: "Where Is the X Sound?",
      prompt: "Where Is the X Sound?",
      background: "x_game_sound_position_bg",
      items: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noXKS" },
      ],
    },
    picturePairs: {
      engine: "memoryPair",
      title: "X Picture Pairs",
      prompt: "X Picture Pairs",
      background: "x_game_picture_pairs_bg",
      items: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
      ],
    },
    soundCall: {
      engine: "callSequence",
      title: "X Sound Call",
      prompt: "X Sound Call",
      background: "x_game_sound_call_bg",
      rounds: [
        {
          id: "box-fox",
          sequence: [
            "box",
            "fox",
          ],
          choices: [
            "fox",
            "taxi",
            "box",
            "six",
          ],
        },
        {
          id: "taxi-mixer",
          sequence: [
            "taxi",
            "mixer",
          ],
          choices: [
            "mixer",
            "ox",
            "fox",
            "taxi",
          ],
        },
        {
          id: "six-ox-box",
          sequence: [
            "six",
            "ox",
            "box",
          ],
          choices: [
            "box",
            "six",
            "taxi",
            "ox",
          ],
        },
      ],
      items: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noXKS" },
      ],
    },
    sentenceClues: {
      engine: "sentenceMeaning",
      title: "X Sentence Clues",
      prompt: "X Sentence Clues",
      background: "x_game_sentence_clues_bg",
      prompts: [
        {
          id: "toy-box",
          visibleFrame: "The toy goes in the ____.",
          spokenInstruction: "The toy goes in the blank. Choose the box.",
          completedSentence: "The toy goes in the box.",
          answer: "box",
          choices: [
            "taxi",
            "box",
            "fox",
          ],
        },
        {
          id: "bushy-fox",
          visibleFrame: "The ____ has a bushy tail.",
          spokenInstruction: "The blank has a bushy tail. Choose the fox.",
          completedSentence: "The fox has a bushy tail.",
          answer: "fox",
          choices: [
            "ox",
            "mixer",
            "fox",
          ],
        },
        {
          id: "count-six",
          visibleFrame: "We count five, then ____.",
          spokenInstruction: "We count five, then blank. Choose six.",
          completedSentence: "We count five, then six.",
          answer: "six",
          choices: [
            "box",
            "six",
            "taxi",
          ],
        },
        {
          id: "parked-taxi",
          visibleFrame: "The yellow ____ is safely parked.",
          spokenInstruction: "The yellow blank is safely parked. Choose the taxi.",
          completedSentence: "The yellow taxi is safely parked.",
          answer: "taxi",
          choices: [
            "taxi",
            "fox",
            "mixer",
          ],
        },
        {
          id: "mixer-batter",
          visibleFrame: "The ____ stirs batter in a bowl.",
          spokenInstruction: "The blank stirs batter in a bowl. Choose the mixer.",
          completedSentence: "The mixer stirs batter in a bowl.",
          answer: "mixer",
          choices: [
            "box",
            "mixer",
            "ox",
          ],
        },
        {
          id: "ox-field",
          visibleFrame: "The calm ____ walks in the field.",
          spokenInstruction: "The calm blank walks in the field. Choose the ox.",
          completedSentence: "The calm ox walks in the field.",
          answer: "ox",
          choices: [
            "fox",
            "taxi",
            "ox",
          ],
        },
      ],
      wordBank: [
        { word: "box", assetName: "x_word_box", isTarget: true, startingSound: "finalXKS" },
        { word: "fox", assetName: "f_word_fox", isTarget: true, startingSound: "finalXKS" },
        { word: "six", assetName: "x_word_six", isTarget: true, startingSound: "finalXKS" },
        { word: "ox", assetName: "x_word_ox", isTarget: true, startingSound: "finalXKS" },
        { word: "taxi", assetName: "x_word_taxi", isTarget: true, startingSound: "medialXKS" },
        { word: "mixer", assetName: "bakery_mixer", isTarget: true, startingSound: "medialXKS" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noXKS" },
        { word: "moon", assetName: "f_distractor_moon", isTarget: true, startingSound: "noXKS" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noXKS" },
      ],
    },
    traceX: {
      engine: "guidedTrace",
      title: "Trace X and x",
      prompt: "Trace X and x",
      background: "x_game_trace_studio_bg",
      cases: {
        uppercase: {
          glyph: "X",
          prompts: [],
          strokes: [
            [{ x: 0.28, y: 0.18 }, { x: 0.72, y: 0.82 }],
            [{ x: 0.72, y: 0.18 }, { x: 0.28, y: 0.82 }],
          ],
          strokeCount: 2,
        },
        lowercase: {
          glyph: "x",
          prompts: [],
          strokes: [
            [{ x: 0.34, y: 0.3 }, { x: 0.66, y: 0.7 }],
            [{ x: 0.66, y: 0.3 }, { x: 0.34, y: 0.7 }],
          ],
          strokeCount: 2,
        },
      }
    },
  },
  Y: {
    soundSlide: {
      engine: "genericTap",
      title: "Y Sound Slide",
      prompt: "Y Sound Slide",
      background: "y_game_sound_slide_bg",
      items: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "Y Case Partners",
      prompt: "Y Case Partners",
      background: "y_game_case_partners_bg",
      items: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    soundPairDetective: {
      engine: "soundPairs",
      title: "Y Sound-Pair Detective",
      prompt: "Y Sound-Pair Detective",
      background: "y_game_sound_pairs_bg",
      pairs: [
        {
          id: "yak-yarn",
          firstWord: "yak",
          secondWord: "yarn",
          bothTarget: true,
        },
        {
          id: "yam-apple",
          firstWord: "yam",
          secondWord: "apple",
          bothTarget: false,
        },
        {
          id: "yoyo-yogurt",
          firstWord: "yo-yo",
          secondWord: "yogurt",
          bothTarget: true,
        },
        {
          id: "yard-fish",
          firstWord: "yard",
          secondWord: "fish",
          bothTarget: false,
        },
        {
          id: "yarn-yam",
          firstWord: "yarn",
          secondWord: "yam",
          bothTarget: true,
        },
      ],
      wordBank: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    callSequence: {
      engine: "callSequence",
      title: "Yellow-Grove Y Call",
      prompt: "Yellow-Grove Y Call",
      background: "y_game_call_sequence_bg",
      rounds: [
        {
          id: "two-pictures",
          sequence: [
            "yak",
            "yam",
          ],
          choices: [
            "yak",
            "yam",
            "yarn",
            "yo-yo",
          ],
        },
        {
          id: "three-pictures",
          sequence: [
            "yarn",
            "yo-yo",
            "yogurt",
          ],
          choices: [
            "yogurt",
            "yard",
            "yo-yo",
            "yarn",
          ],
        },
        {
          id: "four-pictures",
          sequence: [
            "yard",
            "yak",
            "yogurt",
            "yam",
          ],
          choices: [
            "yam",
            "yogurt",
            "yard",
            "yak",
          ],
        },
      ],
      items: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    twoJobs: {
      engine: "genericTap",
      title: "Y Has Two Jobs",
      prompt: "Y Has Two Jobs",
      background: "y_game_two_jobs_bg",
      items: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    meaningGarden: {
      engine: "sentenceMeaning",
      title: "Y Meaning Garden",
      prompt: "Y Meaning Garden",
      background: "y_game_meaning_garden_bg",
      prompts: [
        {
          id: "soft-yarn",
          visibleFrame: "The soft string is called ___.",
          spokenInstruction: "Choose the picture that completes the sentence. The soft string is called yarn.",
          completedSentence: "The soft string is called yarn.",
          answer: "yarn",
        },
        {
          id: "spinning-yoyo",
          visibleFrame: "The spinning toy is a ___.",
          spokenInstruction: "Choose the picture that completes the sentence. The spinning toy is a yo-yo.",
          completedSentence: "The spinning toy is a yo-yo.",
          answer: "yo-yo",
        },
        {
          id: "shaggy-yak",
          visibleFrame: "The shaggy animal is a ___.",
          spokenInstruction: "Choose the picture that completes the sentence. The shaggy animal is a yak.",
          completedSentence: "The shaggy animal is a yak.",
          answer: "yak",
        },
        {
          id: "creamy-yogurt",
          visibleFrame: "I eat the creamy ___.",
          spokenInstruction: "Choose the picture that completes the sentence. I eat the creamy yogurt.",
          completedSentence: "I eat the creamy yogurt.",
          answer: "yogurt",
        },
      ],
      wordBank: [
        { word: "yak", assetName: "y_word_yak", isTarget: true, startingSound: "initialConsonant" },
        { word: "yam", assetName: "y_word_yam", isTarget: true, startingSound: "initialConsonant" },
        { word: "yarn", assetName: "y_word_yarn", isTarget: true, startingSound: "initialConsonant" },
        { word: "yard", assetName: "y_word_yard", isTarget: true, startingSound: "initialConsonant" },
        { word: "yo-yo", assetName: "y_word_yoyo", isTarget: true, startingSound: "initialConsonant" },
        { word: "yogurt", assetName: "y_word_yogurt", isTarget: true, startingSound: "initialConsonant" },
        { word: "puppy", assetName: "d_word_dog", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "bunny", assetName: "f_distractor_rabbit", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "monkey", assetName: "m_word_monkey", isTarget: true, startingSound: "finalVowelLongE" },
        { word: "apple", assetName: "a_word_apple", isTarget: true, startingSound: "noY" },
        { word: "moon", assetName: "a_word_moon", isTarget: true, startingSound: "noY" },
        { word: "fish", assetName: "f_word_fish", isTarget: true, startingSound: "noY" },
      ],
    },
    forkAndTail: {
      engine: "strokeAssembly",
      title: "Build Y's Fork and Tail",
      prompt: "Build Y's Fork and Tail",
      background: "y_game_fork_tail_bg",
      pieces: [
        {
          id: "upper-left-arm",
          x: 0.4,
          y: 0.24,
        },
        {
          id: "upper-right-arm",
          x: 0.6,
          y: 0.24,
        },
        {
          id: "uppercase-stem",
          x: 0.5,
          y: 0.53,
        },
        {
          id: "lowercase-short-arm",
          x: 0.43,
          y: 0.32,
        },
        {
          id: "lowercase-long-tail",
          x: 0.54,
          y: 0.47,
        },
      ],
    },
  },
  Z: {
    soundSlide: {
      engine: "genericTap",
      title: "Z Sound Zoom",
      prompt: "Z Sound Zoom",
      background: "z_game_sound_rainbow_meadow_bg",
      items: [
        { word: "zebra", assetName: "z_word_zebra", isTarget: true },
        { word: "zipper", assetName: "z_word_zipper", isTarget: true },
        { word: "zoo", assetName: "z_word_zoo", isTarget: true },
        { word: "zucchini", assetName: "z_word_zucchini", isTarget: true },
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
      ],
    },
    casePartners: {
      engine: "genericTap",
      title: "Z Case Partners",
      prompt: "Z Case Partners",
      background: "z_game_case_cloud_pavilion_bg",
      items: [
        { word: "zebra", assetName: "z_word_zebra", isTarget: true },
        { word: "zipper", assetName: "z_word_zipper", isTarget: true },
        { word: "zoo", assetName: "z_word_zoo", isTarget: true },
        { word: "zucchini", assetName: "z_word_zucchini", isTarget: true },
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
      ],
    },
    soundPosition: {
      engine: "soundPosition",
      title: "Where Is Z?",
      prompt: "Where Is Z?",
      background: "z_game_position_rainbow_crossroads_bg",
      items: [
        { word: "zebra", assetName: "z_word_zebra", isTarget: true },
        { word: "zipper", assetName: "z_word_zipper", isTarget: true },
        { word: "zoo", assetName: "z_word_zoo", isTarget: true },
        { word: "zucchini", assetName: "z_word_zucchini", isTarget: true },
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
      ],
    },
    zigzagBuilder: {
      engine: "strokeAssembly",
      title: "Build the Zigzag Z",
      prompt: "Build the Zigzag Z",
      background: "z_game_zigzag_workshop_bg",
      notes: "Piece/target layout not fully extractable from Swift (may be code-drawn).",
    },
    doubleZWorkshop: {
      engine: "wordBuilder",
      title: "Double Z Workshop",
      prompt: "Double Z Workshop",
      background: "z_game_double_z_workshop_bg",
      rounds: [
        {
          word: "buzz",
          prefix: "bu",
          endings: [
            "sh",
            "zz",
            "ck",
          ],
          answer: "zz",
        },
        {
          word: "fizz",
          prefix: "fi",
          endings: [
            "zz",
            "sh",
            "t",
          ],
          answer: "zz",
        },
        {
          word: "jazz",
          prefix: "ja",
          endings: [
            "m",
            "zz",
            "ck",
          ],
          answer: "zz",
        },
      ],
    },
    sentenceMeaning: {
      engine: "sentenceMeaning",
      title: "Z Meaning Garden",
      prompt: "Z Meaning Garden",
      background: "z_game_meaning_rainbow_library_bg",
      prompts: [
        {
          id: "striped-zebra",
          visibleFrame: "The striped _____ walks on grass.",
          spokenInstruction: "The striped blank walks on grass. Which picture completes the idea?",
          completedSentence: "The striped zebra walks on grass.",
          answer: "zebra",
          choices: [
            "zoo",
            "zebra",
            "zipper",
          ],
        },
        {
          id: "close-zipper",
          visibleFrame: "Pull the _____ to close the jacket.",
          spokenInstruction: "Pull the blank to close the jacket. Which picture completes the idea?",
          completedSentence: "Pull the zipper to close the jacket.",
          answer: "zipper",
          choices: [
            "zucchini",
            "zipper",
            "zebra",
          ],
        },
        {
          id: "visit-zoo",
          visibleFrame: "We visit the _____ to see animals.",
          spokenInstruction: "We visit the blank to see animals. Which picture completes the idea?",
          completedSentence: "We visit the zoo to see animals.",
          answer: "zoo",
          choices: [
            "zipper",
            "zoo",
            "zucchini",
          ],
        },
        {
          id: "green-zucchini",
          visibleFrame: "The green _____ is a vegetable.",
          spokenInstruction: "The green blank is a vegetable. Which picture completes the idea?",
          completedSentence: "The green zucchini is a vegetable.",
          answer: "zucchini",
          choices: [
            "zebra",
            "zucchini",
            "zoo",
          ],
        },
      ],
      wordBank: [
        { word: "zebra", assetName: "z_word_zebra", isTarget: true },
        { word: "zipper", assetName: "z_word_zipper", isTarget: true },
        { word: "zoo", assetName: "z_word_zoo", isTarget: true },
        { word: "zucchini", assetName: "z_word_zucchini", isTarget: true },
        { word: "apple", assetName: "f_distractor_apple", isTarget: false },
        { word: "fish", assetName: "f_word_fish", isTarget: false },
        { word: "moon", assetName: "f_distractor_moon", isTarget: false },
        { word: "cake", assetName: "f_distractor_cake", isTarget: false },
      ],
    },
    traceZ: {
      engine: "guidedTrace",
      title: "Trace Z and z",
      prompt: "Trace Z and z",
      background: "z_game_trace_sky_studio_bg",
      cases: {
        uppercase: {
          glyph: "Z",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.23, y: 0.21 }, { x: 0.77, y: 0.21 }],
            [{ x: 0.77, y: 0.21 }, { x: 0.23, y: 0.79 }],
            [{ x: 0.23, y: 0.79 }, { x: 0.77, y: 0.79 }],
          ],
          strokeCount: 3,
        },
        lowercase: {
          glyph: "z",
          prompts: [
,
          ],
          strokes: [
            [{ x: 0.31, y: 0.33 }, { x: 0.69, y: 0.33 }],
            [{ x: 0.69, y: 0.33 }, { x: 0.31, y: 0.7 }],
            [{ x: 0.31, y: 0.7 }, { x: 0.69, y: 0.7 }],
          ],
          strokeCount: 3,
        },
      }
    },
  },
};

/** Ordered mini-game ids matching iOS CaseIterable rawValue order. */
export const LETTER_GAME_ORDER_FZ = {
  F: [
    "forestDiscovery",
    "soundSort",
    "fireflyHunt",
    "pictureMatch",
    "flowerGlow",
    "sentenceBuilder",
    "traceF",
  ],
  G: [
    "greenhouseDiscovery",
    "goatCallSequence",
    "letterHunt",
    "pictureMatch",
    "gardenMeaning",
    "sentenceBuilder",
    "traceG",
  ],
  H: [
    "hilltopDiscovery",
    "initialHSort",
    "letterHunt",
    "pictureMatch",
    "honeybeeHelp",
    "sentenceBuilder",
    "traceH",
  ],
  I: [
    "insectDiscovery",
    "shortISort",
    "letterHunt",
    "pictureMatch",
    "longIContrast",
    "wordWorkshop",
    "traceI",
  ],
  J: [
    "jewelDiscovery",
    "initialSoundSort",
    "letterHunt",
    "pictureMatch",
    "jungleJourney",
    "sentenceBuilder",
    "traceJ",
  ],
  K: [
    "keyGardenDiscovery",
    "initialSoundSort",
    "letterHunt",
    "pictureMatch",
    "kiteTrail",
    "sentenceBuilder",
    "traceK",
  ],
  L: [
    "lanternDiscovery",
    "initialSoundSort",
    "letterHunt",
    "pictureMatch",
    "ladybugTrail",
    "sentenceBuilder",
    "traceL",
  ],
  M: [
    "soundMixer",
    "initialSoundSort",
    "casePairing",
    "pictureMatch",
    "missingMBuilder",
    "sentenceBuilder",
    "traceM",
  ],
  N: [
    "soundSlide",
    "pictureMatch",
    "casePairing",
    "soundPosition",
    "soundPairs",
    "sentenceMeaning",
    "traceN",
  ],
  O: [
    "soundSlide",
    "casePairing",
    "soundPairs",
    "echoSequence",
    "missingOBuilder",
    "sentenceMeaning",
    "traceO",
  ],
  P: [
    "soundPuff",
    "soundPairs",
    "casePartners",
    "missingInitial",
    "sentenceMeaning",
    "traceP",
  ],
  Q: [
    "quTeamConnect",
    "casePartners",
    "soundPairDetective",
    "quCallSequence",
    "addTheTail",
    "missingQBuilder",
    "meaningGarden",
  ],
  R: [
    "soundRoad",
    "soundPairs",
    "casePartners",
    "wordRepair",
    "soundRoute",
    "sentenceMeaning",
    "buildR",
  ],
  S: [
    "soundSlider",
    "soundPairs",
    "casePartners",
    "soundSpots",
    "wordBuilder",
    "sentenceSense",
    "traceS",
  ],
  T: [
    "soundTrain",
    "soundPosition",
    "casePartners",
    "tapTrail",
    "wordBuilder",
    "sentenceMeaning",
    "buildT",
  ],
  U: [
    "umbrellaDiscovery",
    "shortUSoundPositions",
    "casePartners",
    "underTheArch",
    "missingUBuilder",
    "sentenceMeaning",
    "traceU",
  ],
  V: [
    "soundSlide",
    "casePartners",
    "soundPairDetective",
    "wordCallSequence",
    "buildV",
    "sentenceMeaning",
    "traceV",
  ],
  W: [
    "soundSlide",
    "casePartners",
    "pictureMemory",
    "soundPairs",
    "buildW",
    "missingWBuilder",
    "sentenceMeaning",
  ],
  X: [
    "soundSpotlight",
    "casePartners",
    "soundPosition",
    "picturePairs",
    "soundCall",
    "sentenceClues",
    "traceX",
  ],
  Y: [
    "soundSlide",
    "casePartners",
    "soundPairDetective",
    "callSequence",
    "twoJobs",
    "meaningGarden",
    "forkAndTail",
  ],
  Z: [
    "soundSlide",
    "casePartners",
    "soundPosition",
    "zigzagBuilder",
    "doubleZWorkshop",
    "sentenceMeaning",
    "traceZ",
  ],
};

/*
 * INCOMPLETE extractions (could not fully pull content from Swift):
 * - K.letterHunt:pieces
 * - O.traceO:strokes
 * - W.buildW:pieces
 * - Z.zigzagBuilder:pieces
 *
 * Notes:
 * - O.traceO:strokes — procedural roundStroke(center/radius); no static polyline in Swift.
 * - K.letterHunt (swiftCase: buildK), W.buildW, Z.zigzagBuilder — strokeAssembly piece
 *   targets are code-drawn at runtime (no static piece/target catalog).
 */

export default LETTER_GAME_CONFIGS_FZ;
